// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:16.833Z
// Property: Signature Place (ID: 6737460151191769)
// Collections: 67 amenities, 19 floorplans (live), 40 photos, 76 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191769",
  "property_external_id": "4882051",
  "property_zillow_url": "https://www.zillow.com/apartments/greenville-nc/signature-place/5Xhynf/",
  "property_apartments_url": "https://www.apartments.com/signature-place-greenville-nc/jylg9e4",
  "property_google_business_url": "https://www.google.com/maps/place/Signature+Place/data=!4m2!3m1!1s0x0:0xd340e6fd33350cb0?sa=X&ved=2ahUKEwjO9IL1vrySAxWxv4kEHTbHGPoQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321283408",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "signature-place",
  "property_name": "Signature Place",
  "property_website_url": "https://www.signatureplaceapartments.com/",
  "property_domain": "https://www.signatureplaceapartments.com/",
  "property_address": "410 Beasley Dr",
  "property_full_address": "410 Beasley Dr, Greenville, NC 27834",
  "property_address_1": "410 Beasley Dr",
  "property_address_2": null,
  "property_address_city": "Greenville",
  "property_address_state": "NC",
  "property_address_zip_full": "27834-7539",
  "property_address_zip": "27834",
  "property_address_country": "US",
  "property_address_county": "Pitt County",
  "property_neighborhood_address": "Medical District",
  "property_address_latitude": "35.6091489",
  "property_address_longitude": "-77.4127405",
  "property_email": "signatureplace@rreafresidential.com",
  "property_phone": "(262) 217-0143",
  "property_call_tracking_phone": "262-228-9294",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Signature Place in Greenville, NC, immerse yourself in comfort and convenience. Choose from our spacious one-, two-, or three-bedroom floor plans. Enjoy amenities like a refreshing pool, modern fitness center, and inviting clubhouse, all designed to enhance your lifestyle. Your perfect home awaits—browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to Signature Place, the premier apartment community in Greenville, NC, where modern living meets exceptional comfort. Our thoughtfully designed floor plans offer a variety of options to suit your lifestyle, including spacious one, two, and three-bedroom apartments. Whether you’re a young professional, a growing family, or looking to downsize, you’ll find the perfect home for your needs. \n\nAt Signature Place, we prioritize your leisure and convenience with a wealth of amenities at your fingertips. Dive into relaxation at our sparkling pool, or break a sweat in our state-of-the-art fitness center. Enjoy the convenience of an on-site concierge and maintenance team, always ready to assist you. Need to focus? Our business center is perfect for working from home, while our inviting clubhouse and lounge areas are great for socializing with neighbors or unwinding after a long day.\n\nLocated in the heart of Greenville, you’ll find yourself in a vibrant community filled with shopping, dining, and entertainment options just steps away. Signature Place is not just a place to live; it’s a lifestyle that embraces comfort, community, and convenience.\n\nDon’t miss out on the chance to call this amazing community home. **Find your new home today – browse our availability or schedule a tour to visit Signature Place!** Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-8747-7662-9b0c-cedfc4a7668e.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and trees",
    "public_id": "019e84aa-8747-7662-9b0c-cedfc4a7668e",
    "storage_key": "property/6737460151191769/019e84aa-8747-7662-9b0c-cedfc4a7668e.webp",
    "width": 3072,
    "height": 2047
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "171",
  "property_year_built": "1981",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.73684210526315",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$150\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Each apartment may have up to 3 pets, with a limit of 2 dogs per home. No breed restrictions.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://signatureplaceapartments.loftliving.com/login",
  "property_apply_now_url": "https://8747933.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-1dd8-745a-ac63-ad690c58d63d.webp",
  "property_primary_logo_media": {
    "alt_text": "Signature Place Apartment Homes logo",
    "public_id": "019e1e24-1dd8-745a-ac63-ad690c58d63d",
    "storage_key": "property/6737460151191769/019e1e24-1dd8-745a-ac63-ad690c58d63d.webp",
    "width": 549,
    "height": 378
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-1dd8-745a-ac63-ad690c58d63d.webp",
  "property_secondary_logo_media": {
    "alt_text": "Signature Place Apartment Homes logo",
    "public_id": "019e1e24-1dd8-745a-ac63-ad690c58d63d",
    "storage_key": "property/6737460151191769/019e1e24-1dd8-745a-ac63-ad690c58d63d.webp",
    "width": 549,
    "height": 378
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84ae-e6a2-70f9-9cc5-83f4030e0fb0.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e84ae-e6a2-70f9-9cc5-83f4030e0fb0",
    "storage_key": "property/6737460151191769/019e84ae-e6a2-70f9-9cc5-83f4030e0fb0.webp",
    "width": 549,
    "height": 378
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-1e36-755b-85d4-0679f93e6b30.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Signature Place Apartment Homes logo",
    "public_id": "019e1e24-1e36-755b-85d4-0679f93e6b30",
    "storage_key": "property/6737460151191769/019e1e24-1e36-755b-85d4-0679f93e6b30.webp",
    "width": 549,
    "height": 378
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#124556",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "706 - 1400",
  "property_sqft_min": "706",
  "property_sqft_max": "1400",
  "property_price_range": "935 - 1495",
  "property_price_min": "935",
  "property_price_max": "1495",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/SignaturePlaceGreenville/",
  "property_instagram_url": "https://www.instagram.com/signature_place_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZ4dxhy_orokRsAw1M_3mQNM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Greenville%2C+NC",
  "property_tiktok_url": "https://www.tiktok.com/@signature.place",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Signature Place",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "<p>Welcome to Signature Place, a great community with beautiful wooded views and modern conveniences. Take time to explore the variety of shops, local restaurants, and entertainment just minutes away. The nearby River Park North has 324 acres for anyone who enjoys boating, hiking, camping, fishing, or just a picnic in the park. <a href=\"/neighborhood/\">Discover everything Greenville, NC</a> has to offer at Signature Place.</p>",
  "property_home_floorplans_blurb": "<p><a href=\"/gallery/\">Signature Place</a> is conveniently located in Greenville, NC with easy access to everything you could want or need! Shopping, restaurants, schools, entertainment venues; you name it, it's all within minutes of your new home.</p>",
  "property_home_gallery_blurb": "Welcome to Signature Place in Greenville, NC, where comfort meets style. Choose from our thoughtfully designed one, two, or three-bedroom floor plans. Enjoy breathtaking wooded views, a resort-style swimming pool, and a newly revamped athletic club. Picture yourself unwinding on your private balcony or socializing at resident events!",
  "property_home_neighborhood_blurb": "At Signature Place in Greenville, NC, vibrant living welcomes you with stylish one, two, and three-bedroom floor plans. Nestled in a lively neighborhood, our community offers unmatched convenience and charm. Uncover local favorites and hidden gems just around the corner—adventure awaits at every turn!",
  "property_home_reviews_blurb": "At Signature Place in vibrant Greenville, NC, residents rave about the “welcoming atmosphere and attentive staff.” Join a community where comfort and convenience meet, and experience an exceptional lifestyle. Curious about life here? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p><a href=\"/gallery/\">Signature Place</a> is conveniently located in Greenville, NC with easy access to everything you could want or need! Shopping, restaurants, schools, entertainment venues; you name it, it's all within minutes of your new home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Signature Place, our on-site management team, 24-hour emergency maintenance, and Spanish-speaking staff are there for you. Come and relax in our upgraded clubhouse or get your heart pumping at our new athletic club! We understand that pets are part of the family. That's why your pets are welcome to join our community at Signature Place. Contact us today and make your next move into Signature Place in <a href=\"/neighborhood/\">Greenville, North Carolina!</a></p>",
  "property_applynow_blurb": "At Signature Place in Greenville, NC, choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy resort-style amenities like a refreshing pool, fitness center, and clubhouse. Our dedicated concierge and on-site maintenance ensure you experience comfort and convenience. Find your new home and lease online today!",
  "property_contactus_blurb": "At Signature Place in Greenville, NC, we offer thoughtfully designed one, two, and three-bedroom apartments that cater to your lifestyle. With spacious layouts and modern finishes, your perfect home awaits. Have questions? Our friendly leasing team is ready to assist you—reach out today to start your journey!",
  "property_faqs_blurb": "At Signature Place in Greenville, NC, your ideal living space awaits—choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored for comfort and style. Have questions? Our FAQs page is a treasure trove of insights to enhance your community experience. Dive in to learn more!",
  "property_floorplans_blurb": "<p>Choose from spacious 1, 2, and 3 bedroom garden-style or 2 and 3 bedroom two-story apartments to find the perfect home that suits your lifestyle. Certain homes include modern black appliances, all-white kitchen cabinetry, subway tile backsplash, and pendant lighting. Each home features <a href=\"/amenities/\">standard amenities</a> such as ceiling fans, large closets, and full-size washer and dryer connections. With five floor plans to choose from, you're sure to find your ideal home here at Signature Place.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Signature Place in Greenville, NC, we redefine comfort with stunning one, two, and three-bedroom apartments. Dive into our inviting pool, energize in the fitness center, or unwind in the clubhouse lounge. Navigate our interactive community map to find your ideal home today and explore pricing options that fit your lifestyle!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Signature Place in Greenville, NC, vibrant living awaits in our thoughtfully designed one, two, and three-bedroom apartments. Invite your friends to share in the experience! Great friends make great neighbors—refer a friend today and enjoy a thriving community where connections blossom and memories are made.",
  "property_residentaccess_blurb": "Welcome to Signature Place in Greenville, NC—your perfect home awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans tailored for comfort. Need assistance? Access your resident portal for hassle-free rent payments, maintenance requests, and more. Elevate your living experience today!",
  "property_reviews_blurb": "At Signature Place in Greenville, NC, residents rave about their home: \"The community feels like family, and the amenities are top-notch!\" Dive into the heartfelt reviews that showcase why our apartments are not just a place to live, but a vibrant community. See what our residents have to say about living at our community!",
  "property_created_at": "1752257094410",
  "property_scheduletour_blurb": "At Signature Place in Greenville, NC, choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Experience a vibrant community where every detail matters. Schedule a tour today and hear firsthand from our satisfied residents why they love calling Signature Place home!",
  "property_thankyou_blurb": "Thank you for reaching out to Signature Place in vibrant Greenville, NC! Our diverse floor plans, including one, two, and three-bedroom options, cater to your unique lifestyle. A member of our team will connect with you soon to help you find your perfect home sweet home.",
  "property_virtualtours_blurb": "<p>At Signature Place, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360 degree views of your new apartment home today!</p>",
  "property_copyright": "2025 All Rights Reserved. Signature Place",
  "property_seo_title_home": "Signature Place | Apartments in Greenville, NC",
  "property_seo_description_home": "Experience elevated living at Signature Place in Greenville, NC, where every floor plan—whether it’s a cozy one-bedroom or a spacious three-bedroom—perfectly blends comfort and style. Enjoy top-tier amenities, including a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse for social gatherings. With an on-site concierge, maintenance team, and a dynamic business center, your every need is expertly catered to. Step into a lifestyle that balances leisure and productivity. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Greenville, NC",
  "property_seo_description_floorplans": "Unveil your ideal living space at Signature Place in Greenville, NC! From cozy one-bedroom retreats to spacious three-bedroom designs, our thoughtfully crafted floor plans cater to every lifestyle. Whether you’re looking for a sleek, modern apartment or a generous space for your family, Signature Place has something special waiting for you. Browse our stunning options today and let your new home story begin!",
  "property_seo_title_amenities": "Amenities | Greenville, NC Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Signature Place in Greenville, NC, where comfort meets convenience! Choose from stylish one, two, or three-bedroom floor plans, and elevate your lifestyle with our luxurious amenities. Dive into our refreshing pool, stay fit in our state-of-the-art fitness center, or unwind in the relaxing lounge and clubhouse. With a concierge at your service and maintenance on-site, your every need is catered to. Visit our amenities page to envision your new home!",
  "property_seo_title_gallery": "Gallery | Apartments in Greenville, NC",
  "property_seo_description_gallery": "\"Step into the vibrant lifestyle at Signature Place in Greenville, NC, where each stunning photo brings your dream home to life! From inviting one to spacious three-bedroom floor plans, our community boasts resort-style amenities like a shimmering pool, cutting-edge fitness center, and a welcoming clubhouse. With convenient services like an elevator and on-site maintenance, luxury living has never been so accessible. Picture yourself living here—your oasis awaits in our exclusive photo gallery!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Signature Place Apartments",
  "property_seo_description_virtualtours": "Step into your future at Signature Place in Greenville, NC! Experience the spacious comfort of our thoughtfully designed one, two, and three-bedroom apartments. With a virtual tour, you'll get an exclusive glimpse into vibrant living spaces and community amenities that redefine home. Ready to envision your new lifestyle? Take the virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Signature Place Apartments",
  "property_seo_description_interactivemap": "\"Uncover your perfect haven at Signature Place in Greenville, NC. With thoughtfully designed floor plans ranging from one to three bedrooms, our community offers a lifestyle enriched with exceptional amenities—from a refreshing pool and state-of-the-art fitness center to a welcoming clubhouse and concierge services. Navigate effortlessly through our interactive community map to find available apartments, compare pricing, and envision your new home today!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Greenville, NC",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle of Greenville, NC, at Signature Place. Uncover the charm of our neighborhood, filled with local favorites, scenic parks, and exciting attractions just moments from your doorstep. Check out what awaits you in this thriving community and find your perfect spot in the heart of it all!",
  "property_seo_title_contact": "Contact Us | Signature Place",
  "property_seo_description_contact": "Experience life at Signature Place in Greenville, NC, where modern living meets comfort. Choose from our thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Whether you're seeking a cozy retreat or a spacious haven, we've got the perfect home for you. Have questions? Our friendly leasing team is just a message away—contact us today to learn more!",
  "property_seo_title_faqs": "FAQs | Apartments in Greenville, NC",
  "property_seo_description_faqs": "\"At Signature Place in Greenville, NC, your comfort and convenience come first. Our welcoming community offers a diverse selection of one, two, and three-bedroom floor plans, complemented by an array of top-notch amenities including a sparkling pool, fitness center, concierge services, and more. Got questions? Our FAQs page has all the answers to help you feel right at home. Swing by and get acquainted with everything Signature Place has to offer!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Greenville, NC",
  "property_seo_description_reviews": "Join the vibrant community at Signature Place in Greenville, NC, where every resident's voice matters! Dive into authentic experiences shared by our residents in the reviews section. Whether you relish the inviting pool, stay active in the fitness center, or unwind in our stylish clubhouse, there's a story waiting for you. Learn how our on-site maintenance and concierge services elevate daily life. See for yourself why Signature Place isn’t just a home, but a lifestyle!",
  "property_seo_title_applynow": "Apply Now | Apartments in Greenville, NC",
  "property_seo_description_applynow": "Elevate your living at Signature Place in vibrant Greenville, NC! With a variety of spacious floor plans—including one, two, and three-bedroom apartments—there's a perfect fit for every lifestyle. Enjoy premium amenities like a refreshing pool, a state-of-the-art fitness center, and a stylish clubhouse, all designed to enhance your everyday experience. Ready to make the move? Apply now and secure your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Signature Place",
  "property_seo_description_residentaccess": "\"Welcome to Signature Place in Greenville, NC! Log in to your resident portal for hassle-free rent payments, seamless maintenance requests, and exclusive community updates—all designed to enhance your living experience.\"",
  "property_seo_title_referafriend": "Refer A Friend | Signature Place",
  "property_seo_description_referafriend": "\"At Signature Place in Greenville, NC, great friends make great neighbors! Share the joy of our vibrant community with a referral and unlock exclusive rewards. Invite your friends to experience easy living with top-notch amenities and a welcoming atmosphere! Refer today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Signature Place",
  "property_seo_description_scheduletour": "\"Step into your new lifestyle at Signature Place in Greenville, NC! Experience exceptional amenities and vibrant living spaces by scheduling a tour of our community today. Your dream home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Signature Place",
  "property_seo_description_privacy": "\"At Signature Place in Greenville, NC, your peace of mind matters. Dive into our Privacy Policy to see how we safeguard your personal information while you enjoy the comforts of home. Your privacy, our promise.\"",
  "property_seo_title_accessibility": "Website Accessibility | Signature Place",
  "property_seo_description_accessibility": "\"At Signature Place in Greenville, NC, we believe in accessibility for all. Our commitment to digital inclusion ensures that everyone can easily navigate our resources and enjoy a seamless living experience. Join us in creating a welcoming community where every voice matters.\"",
  "property_seo_title_sitemap": "Sitemap | Signature Place",
  "property_seo_description_sitemap": "\"Navigate your way to comfort and style at Signature Place in Greenville, NC. Our sitemap provides a clear path to find your ideal apartment, community amenities, and everything that makes Signature Place your next home sweet home.\"",
  "property_seo_title_thankyou": "Thank You | Signature Place",
  "property_seo_description_thankyou": "Thank you for reaching out to Signature Place in Greenville, NC! Your interest in our vibrant community is appreciated. Our team will be in touch soon to help you find your ideal home where style meets comfort. Stay tuned for personalized assistance!",
  "property_seo_title_pets": "Pet Policy | Apartments in Greenville, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293557673",
  "amenities": [
    {
      "id": "ec_b438891b23b51d1f543e6772",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc6cea9ce1d82df3830b8577",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e3516c23714fd2ab01421c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83b6d141b201f3b3a312be27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1e7e636eea3f07061e0cc4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Wash Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c389385058c1c5b0c817d184",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Furnished Units Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09cc34cf05590bf0ea4b1544",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3de250607b416f24a44c6a4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ff8567a7ac78437fe8eeb7b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5bb3f8a27019de7a2b5a7e13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e974265d6ab4c6d981a88ed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36d24bbeacc88760aa04a12c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Curbside",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_705f4da8f51c28ddb73e05e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b07df979c5fb039364563125",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Community-Wide WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22e587827adea0f2f1e15d5a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d964ee75114b61db03a0b0d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67110730f6d74e7e64970778",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Vision Impaired Accessible",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e3bcb3dc945db31cf9423a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c382295d29dbdf3b43fa68f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aecbaec0e860f4f22e59e17e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Tanning Salon",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17fbccbfff94cbdd46905ac9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b45d7a678a1fc705c71a1cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Multi Use Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f928d55f53016d3ead1efb56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efcd08682c9a7739f5fdada1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41f60c3b41fbb0edcbf3eeae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96eb0be9d2bdb928060dbe8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2afe8a7c778c1fa9be4ac4c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88ffcec43b03fc6286bb7ec7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0027db65f75aed66450b7fed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Zen Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b205b1253295c0dfcbd7d1a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1092b7785c07f09713536f3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e12d726d0dadac20989dc335",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2df31ca65621316aff8fca7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2eb6db503b5f1f9052d49884",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ecada9446cf8f3de0c929dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_055c9e3a8d55a41cd097c578",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3c3c876ed77aabd7b1b06d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43b7a9aebec2b54be585ae55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69cf90315955476fb5efb90c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb2c178e5946ad96308f70cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_383a7f3cdcb926b57a5ab1cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46efe6db0ead2c74a4140247",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb5812a80edebe4c41ac9867",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_122ab92ac8425255a2fc2fd2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac533046ab7f61da19fa1611",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_140cb92034ef1dee1759c6e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Eat-in Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a43e3c4c7c8af6b3dd31d59b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6dba6ad46dfb283c94960ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_204e7deead3b318f03e0e50d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24ad13358eb13b338f6567a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_caefd37d0efead92dfa8fa9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efb14d062226aa4b5452039d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_049ef287aeddb28647fa3bd0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d42245b9a124481e30e734c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62dfeca61bdbe1ca17e48d69",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d29f54c945fd1bc04e7976d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05cfc7512db0c825403c0cb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd34d44dbd0aa67561305037",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e84002bcf5647653ca863f80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Pane Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cf3bb1310aafa5bc916dab0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3f76b6aaa40a61b66ec4f5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bac6f6da0a9c41f770208a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d96f2da5f986bcf30f73aaab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_813e6fd38bd0ad5b0bff9024",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Floor to Ceiling Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9010a12de00ce9598ec93307",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dce1fcb4dbfa4393721323b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4187acbf173bc0ac8a88f37b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "apartments",
      "external_id": "false",
      "title": "Porch",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_326c0d9a-cb6c-4f3d-820f-b2d87fa59fb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-3c86-742d-9884-4c9cd731e2c0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under an umbrella.",
        "public_id": "01a0397b-3c86-742d-9884-4c9cd731e2c0",
        "storage_key": "property/6737460151191769/01a0397b-3c86-742d-9884-4c9cd731e2c0.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables under an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6b908883-981f-40ee-b505-0c7342fb9cb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-2897-7383-a58c-caa68996f4a4.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, accent chair, and dining area.",
        "public_id": "01a0397b-2897-7383-a58c-caa68996f4a4",
        "storage_key": "property/6737460151191769/01a0397b-2897-7383-a58c-caa68996f4a4.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, accent chair, and a modern dining set, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, accent chair, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a98cdf68-edb5-454e-9e84-ca2a077e7943",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-282d-72b0-b1e3-ff1c499c8193.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel sink, black dishwasher, and black stove.",
        "public_id": "01a0397b-282d-72b0-b1e3-ff1c499c8193",
        "storage_key": "property/6737460151191769/01a0397b-282d-72b0-b1e3-ff1c499c8193.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring white cabinetry, a double basin sink, and modern black appliances including a dishwasher and stove.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel sink, black dishwasher, and black stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e68ce627-b85a-4008-925a-aed67f1b576d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-2a37-70d8-a554-3ffacb532337.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, an elliptical, a rowing machine, and a stationary bike.",
        "public_id": "01a0397b-2a37-70d8-a554-3ffacb532337",
        "storage_key": "property/6737460151191769/01a0397b-2a37-70d8-a554-3ffacb532337.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring treadmills, an elliptical, a rowing machine, and a stationary bike. A perfect place to achieve your fitness goals.",
      "link": "",
      "alt_text": "Fitness center with treadmills, an elliptical, a rowing machine, and a stationary bike.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_12fa344f-8021-4d57-b08e-fe529fd6932c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a03979-f155-76be-b397-b3bc66d60f2b.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with large windows and a sleek kitchen visible.",
        "public_id": "01a03979-f155-76be-b397-b3bc66d60f2b",
        "storage_key": "property/6737460151191769/01a03979-f155-76be-b397-b3bc66d60f2b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a spacious living area, elegant dining space, and a modern, open-concept kitchen.",
      "link": "",
      "alt_text": "Modern living and dining area with large windows and a sleek kitchen visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec3a1b73-46fc-4b81-9aca-5ffcbcd275de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-2aa7-711b-91df-834e0ac9af2b.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, and dining area with kitchen in background.",
        "public_id": "01a0397b-2aa7-711b-91df-834e0ac9af2b",
        "storage_key": "property/6737460151191769/01a0397b-2aa7-711b-91df-834e0ac9af2b.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, and dining area with kitchen in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_573b26c0-a1dc-4a48-a84d-298679ad0bbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-3fd6-767e-a7e0-1cb6a2b70b9c.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with comfortable seating areas and a dining table.",
        "public_id": "01a0397b-3fd6-767e-a7e0-1cb6a2b70b9c",
        "storage_key": "property/6737460151191769/01a0397b-3fd6-767e-a7e0-1cb6a2b70b9c.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring ample seating and a large dining area perfect for gatherings.",
      "link": "",
      "alt_text": "Spacious community lounge with comfortable seating areas and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99c6f915-3403-4707-870a-f0551e159cf3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-3e8c-771b-9622-652a7d6ec580.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, rowing machine, cable crossover machine, and punching bag.",
        "public_id": "01a0397b-3e8c-771b-9622-652a7d6ec580",
        "storage_key": "property/6737460151191769/01a0397b-3e8c-771b-9622-652a7d6ec580.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Modern apartment gym with treadmills, rowing machine, cable crossover machine, and punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_437c9951-214a-40a2-8ab1-955b90c27227",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-2c7d-77f9-91ff-04ef11c6dcdb.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with storage shelves above and a fire extinguisher on the wall.",
        "public_id": "01a0397b-2c7d-77f9-91ff-04ef11c6dcdb",
        "storage_key": "property/6737460151191769/01a0397b-2c7d-77f9-91ff-04ef11c6dcdb.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities featuring a washer and dryer, complemented by overhead shelving for storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with storage shelves above and a fire extinguisher on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a251d549-101b-4ee5-9239-85f7b604efc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/01a0397b-26d7-773d-9928-f583046cdee3.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with two grills under a wooden pergola with string lights.",
        "public_id": "01a0397b-26d7-773d-9928-f583046cdee3",
        "storage_key": "property/6737460151191769/01a0397b-26d7-773d-9928-f583046cdee3.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our state-of-the-art outdoor kitchen, complete with dual grills and ample counter space, perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor kitchen with two grills under a wooden pergola with string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9e4dcf5-718c-4131-99a0-19817c7b4560",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-8a4f-77e0-bdb2-e6f17213929e.webp",
      "image_media": {
        "alt_text": "Sun loungers by a swimming pool with trees in the background",
        "public_id": "019e84aa-8a4f-77e0-bdb2-e6f17213929e",
        "storage_key": "property/6737460151191769/019e84aa-8a4f-77e0-bdb2-e6f17213929e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling blue swimming pool, complete with comfortable sun loungers and lush green trees.",
      "link": "",
      "alt_text": "Sun loungers by a swimming pool with trees in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0eea0f97-b11c-4391-a8e4-9faa61d3cfed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-8b8a-72b5-823b-5ea87848b44c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
        "public_id": "019e84aa-8b8a-72b5-823b-5ea87848b44c",
        "storage_key": "property/6737460151191769/019e84aa-8b8a-72b5-823b-5ea87848b44c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior of apartment buildings featuring brick accents, siding, and neat landscaping, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4108d035-5219-4711-aa6d-d27a12b6f7bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-8b82-7434-b14d-27efdc1479d7.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and siding, manicured lawns, and parking spaces.",
        "public_id": "019e84aa-8b82-7434-b14d-27efdc1479d7",
        "storage_key": "property/6737460151191769/019e84aa-8b82-7434-b14d-27efdc1479d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings featuring a mix of brick and siding exteriors, surrounded by lush landscaping and convenient parking.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with brick and siding, manicured lawns, and parking spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_95fed5bd-7220-486c-b585-bf3a728e8921",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-b9bc-77b5-b8c1-39ecb345204c.webp",
      "image_media": {
        "alt_text": "Kitchen sink with stainless steel double basin and faucet, window with blinds in the background.",
        "public_id": "019e84aa-b9bc-77b5-b8c1-39ecb345204c",
        "storage_key": "property/6737460151191769/019e84aa-b9bc-77b5-b8c1-39ecb345204c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a double stainless steel sink and faucet, complemented by bright white cabinetry and a large window overlooking the outdoors.",
      "link": "",
      "alt_text": "Kitchen sink with stainless steel double basin and faucet, window with blinds in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3552b516-076a-4016-a94f-f71cb67ec641",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-bdd0-76ba-bbfb-c9eb208cf2d8.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and window blinds.",
        "public_id": "019e84aa-bdd0-76ba-bbfb-c9eb208cf2d8",
        "storage_key": "property/6737460151191769/019e84aa-bdd0-76ba-bbfb-c9eb208cf2d8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring plush carpeting, a modern ceiling fan, and natural light streaming through the window blinds.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and window blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d9a3260a-3ed2-4e5b-bbc8-90b832977000",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-bbcb-720b-9bea-4128a9698c33.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and closet.",
        "public_id": "019e84aa-bbcb-720b-9bea-4128a9698c33",
        "storage_key": "property/6737460151191769/019e84aa-bbcb-720b-9bea-4128a9698c33.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring neutral paint, plush carpeting, a ceiling fan, and ample closet space.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_042c35aa-9fe3-4687-88d2-42167600426c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-6c18-75ba-b8d9-9010e04b5fc3.webp",
      "image_media": {
        "alt_text": "Office building entrance with rocking chairs and landscaping.",
        "public_id": "019e84aa-6c18-75ba-b8d9-9010e04b5fc3",
        "storage_key": "property/6737460151191769/019e84aa-6c18-75ba-b8d9-9010e04b5fc3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the leasing office, where our friendly staff is ready to assist you.",
      "link": "",
      "alt_text": "Office building entrance with rocking chairs and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d27211bb-c3f0-44a4-a91e-7a82fadbd801",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-afbb-704d-9dc7-284f738c70ff.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel sink, black stove, and dishwasher.",
        "public_id": "019e84aa-afbb-704d-9dc7-284f738c70ff",
        "storage_key": "property/6737460151191769/019e84aa-afbb-704d-9dc7-284f738c70ff.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and functional kitchen featuring white cabinetry, a double basin sink, a black stove, and a dishwasher, perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel sink, black stove, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80850b57-eadf-4fc9-b80d-b027b71de2b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-b1b1-768a-a99c-93f0396f0f88.webp",
      "image_media": {
        "alt_text": "Spacious living room with natural light and access to kitchen.",
        "public_id": "019e84aa-b1b1-768a-a99c-93f0396f0f88",
        "storage_key": "property/6737460151191769/019e84aa-b1b1-768a-a99c-93f0396f0f88.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright and airy living room with modern finishes, leading to a well-equipped kitchen. Perfect for comfortable living.",
      "link": "",
      "alt_text": "Spacious living room with natural light and access to kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_186810f7-cb5a-4f94-919b-016a8b4e5056",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-abcd-7038-9216-66f58435b257.webp",
      "image_media": {
        "alt_text": "Empty living room and entryway with wood-look flooring and neutral walls.",
        "public_id": "019e84aa-abcd-7038-9216-66f58435b257",
        "storage_key": "property/6737460151191769/019e84aa-abcd-7038-9216-66f58435b257.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this inviting living space, featuring durable wood-look flooring and neutral, calming walls. An open layout connects to the entryway, offering a welcoming first impression.",
      "link": "",
      "alt_text": "Empty living room and entryway with wood-look flooring and neutral walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0bbbc111-a33e-40bf-88f8-1d57f85359b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-afeb-76fb-a0d7-a3e6263b7447.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two closets and a ceiling fan.",
        "public_id": "019e84aa-afeb-76fb-a0d7-a3e6263b7447",
        "storage_key": "property/6737460151191769/019e84aa-afeb-76fb-a0d7-a3e6263b7447.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring two large closets and a ceiling fan, perfect for a comfortable living space.",
      "link": "",
      "alt_text": "Empty bedroom with two closets and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3449b8e6-4d39-44b6-bdd6-bd77bb3f3607",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-ad68-76ef-8736-af483b51b134.webp",
      "image_media": {
        "alt_text": "Interior view of a vacant apartment unit showing wood-look flooring and white doors.",
        "public_id": "019e84aa-ad68-76ef-8736-af483b51b134",
        "storage_key": "property/6737460151191769/019e84aa-ad68-76ef-8736-af483b51b134.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and bright living area in an apartment unit, featuring modern wood-look flooring and neutral wall colors. The entrance to the unit is visible, offering a glimpse into the hallway.",
      "link": "",
      "alt_text": "Interior view of a vacant apartment unit showing wood-look flooring and white doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_697678df-9d8c-4c74-b8b2-c0e4f1cb71d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-bbc0-76cb-82e5-0bd4788772c1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, shower, and toilet.",
        "public_id": "019e84aa-bbc0-76cb-82e5-0bd4788772c1",
        "storage_key": "property/6737460151191769/019e84aa-bbc0-76cb-82e5-0bd4788772c1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in our modern bathrooms, featuring a sleek bathtub, shower, and toilet for your daily relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, shower, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_597cd86a-db50-483a-b171-de1b208899d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-b7ec-70f1-bb92-164fe0185077.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with a shelf above.",
        "public_id": "019e84aa-b7ec-70f1-bb92-164fe0185077",
        "storage_key": "property/6737460151191769/019e84aa-b7ec-70f1-bb92-164fe0185077.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs, complete with a shelf for extra storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer with a shelf above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a5e6427-a50c-419c-82be-09211fdb6619",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-ad7d-734e-993c-e4e66a6aa58f.webp",
      "image_media": {
        "alt_text": "Bedroom with two closets, a ceiling fan, and a window with blinds.",
        "public_id": "019e84aa-ad7d-734e-993c-e4e66a6aa58f",
        "storage_key": "property/6737460151191769/019e84aa-ad7d-734e-993c-e4e66a6aa58f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring neutral tones, a ceiling fan for comfort, ample closet space, and a large window that lets in natural light.",
      "link": "",
      "alt_text": "Bedroom with two closets, a ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5819129-aed8-409e-9c33-9d14a660c8f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-abcb-760e-bef2-bc7a9e712031.webp",
      "image_media": {
        "alt_text": "Empty bedroom with white doors, ceiling fan, and wood-look flooring.",
        "public_id": "019e84aa-abcb-760e-bef2-bc7a9e712031",
        "storage_key": "property/6737460151191769/019e84aa-abcb-760e-bef2-bc7a9e712031.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience a spacious and modern living area with neutral tones, a convenient ceiling fan, and stylish wood-look flooring. This bedroom offers ample space for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with white doors, ceiling fan, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ddfc42bc-8546-4264-8ac0-200a79626d09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-abff-736a-b3de-eec9a64c8aa8.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, and mirror.",
        "public_id": "019e84aa-abff-736a-b3de-eec9a64c8aa8",
        "storage_key": "property/6737460151191769/019e84aa-abff-736a-b3de-eec9a64c8aa8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and simple bathroom featuring a toilet, a vanity with a sink and faucet, and a mirror above.",
      "link": "",
      "alt_text": "Bathroom with toilet, vanity, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc0363a5-d306-4fe9-b18a-7004382797a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-4876-7630-865f-0950f498a18e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
        "public_id": "019e84aa-4876-7630-865f-0950f498a18e",
        "storage_key": "property/6737460151191769/019e84aa-4876-7630-865f-0950f498a18e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed18c91a-775e-4db2-9dd6-cde1e5d034fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-3c33-744d-a283-34bbc5eb351c.webp",
      "image_media": {
        "alt_text": "Playground with blue and orange equipment and a beige slide.",
        "public_id": "019e84aa-3c33-744d-a283-34bbc5eb351c",
        "storage_key": "property/6737460151191769/019e84aa-3c33-744d-a283-34bbc5eb351c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring vibrant blue and orange equipment and a large beige slide for endless entertainment.",
      "link": "",
      "alt_text": "Playground with blue and orange equipment and a beige slide.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45288419-3a3c-4e28-91fa-6eeb72dac852",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-3f1f-772a-8385-a73487517138.webp",
      "image_media": {
        "alt_text": "Hammock lounge area with sand pit and trees",
        "public_id": "019e84aa-3f1f-772a-8385-a73487517138",
        "storage_key": "property/6737460151191769/019e84aa-3f1f-772a-8385-a73487517138.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our shaded hammock lounge, a perfect spot to enjoy the outdoors.",
      "link": "",
      "alt_text": "Hammock lounge area with sand pit and trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8bc31fea-c2b8-41e0-b83b-1d573cf52380",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-999f-72d8-9e79-f10fd439d022.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral walls, wood-look flooring, a ceiling fan, and a closet.",
        "public_id": "019e84aa-999f-72d8-9e79-f10fd439d022",
        "storage_key": "property/6737460151191769/019e84aa-999f-72d8-9e79-f10fd439d022.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring neutral paint, modern wood-look flooring, a ceiling fan, and ample closet space.",
      "link": "",
      "alt_text": "Empty bedroom with neutral walls, wood-look flooring, a ceiling fan, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_480d5b5f-52e6-4b90-ad05-37aa168d8971",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-99c3-7318-b6b2-b0cbab7829db.webp",
      "image_media": {
        "alt_text": "Black electric stove with four burners and oven, beneath white cabinets and a black range hood.",
        "public_id": "019e84aa-99c3-7318-b6b2-b0cbab7829db",
        "storage_key": "property/6737460151191769/019e84aa-99c3-7318-b6b2-b0cbab7829db.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring a black electric stove, white cabinetry, and a grey countertop. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Black electric stove with four burners and oven, beneath white cabinets and a black range hood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_369f0cd8-f136-4a5b-9112-29f3112c6463",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-915a-730a-882f-13c71026a8a0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, white cabinets, and granite countertops.",
        "public_id": "019e84aa-915a-730a-882f-13c71026a8a0",
        "storage_key": "property/6737460151191769/019e84aa-915a-730a-882f-13c71026a8a0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A bright and updated kitchen featuring stainless steel appliances, ample cabinet storage, and a double sink with a modern black faucet.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9397345f-4808-45b9-bf65-452924d69a94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-9030-7166-9d29-87d8fbcd3973.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and towel rack.",
        "public_id": "019e84aa-9030-7166-9d29-87d8fbcd3973",
        "storage_key": "property/6737460151191769/019e84aa-9030-7166-9d29-87d8fbcd3973.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a single vanity with a white sink, a dark-framed mirror, and a wall-mounted towel rack.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and towel rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_993dca71-1e2e-4d47-82b8-71c4117a4523",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-7112-70ff-b214-bf82b0f913af.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, benches, and trees.",
        "public_id": "019e84aa-7112-70ff-b214-bf82b0f913af",
        "storage_key": "property/6737460151191769/019e84aa-7112-70ff-b214-bf82b0f913af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, featuring agility equipment and comfortable seating for you and your furry friends.",
      "link": "",
      "alt_text": "Dog park with agility equipment, benches, and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d29eeb28-c4d0-48c2-ba3d-923e35fdec32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-9294-75a5-b5e9-1bacea5014d0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees in the background.",
        "public_id": "019e84aa-9294-75a5-b5e9-1bacea5014d0",
        "storage_key": "property/6737460151191769/019e84aa-9294-75a5-b5e9-1bacea5014d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad506e15-a75d-406f-9908-8a43e5b456c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-8747-7662-9b0c-cedfc4a7668e.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and trees",
        "public_id": "019e84aa-8747-7662-9b0c-cedfc4a7668e",
        "storage_key": "property/6737460151191769/019e84aa-8747-7662-9b0c-cedfc4a7668e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by lush greenery. Relax on the comfortable lounge chairs or gather with friends under the shaded cabana.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7db84c42-0442-4a7b-96e7-28f5fdb4de23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-6538-77f1-b90c-4ccff8b6b987.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with table and chairs under a striped umbrella.",
        "public_id": "019e84aa-6538-77f1-b90c-4ccff8b6b987",
        "storage_key": "property/6737460151191769/019e84aa-6538-77f1-b90c-4ccff8b6b987.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining or relaxation in this comfortable seating area, perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "Outdoor seating area with table and chairs under a striped umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_53ff7097-1e4d-4093-933c-adeee9a94a80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-5fd4-7799-bbfc-2601a5be0ceb.webp",
      "image_media": {
        "alt_text": "Office building exterior with ramps and stairs.",
        "public_id": "019e84aa-5fd4-7799-bbfc-2601a5be0ceb",
        "storage_key": "property/6737460151191769/019e84aa-5fd4-7799-bbfc-2601a5be0ceb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the leasing office for Signature Place Apartments, featuring a welcoming ramp and stairs for easy access.",
      "link": "",
      "alt_text": "Office building exterior with ramps and stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d6303f6c-6d30-4d5a-bf7b-fde46bc8da18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e84aa-3de5-72bb-a83d-affa575dadb3.webp",
      "image_media": {
        "alt_text": "Bark Park sign with a corgi and a bone graphic",
        "public_id": "019e84aa-3de5-72bb-a83d-affa575dadb3",
        "storage_key": "property/6737460151191769/019e84aa-3de5-72bb-a83d-affa575dadb3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Showcasing our pet-friendly community with a dedicated Bark Park for your furry friends to enjoy.",
      "link": "",
      "alt_text": "Bark Park sign with a corgi and a bone graphic",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fde68cf4-fec5-4258-8710-72d92c3e3388",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Villa Verde DOS",
      "poi_type": "Restaurants",
      "poi_address": "2247 W Arlington Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "Counter-serve restaurant offering burritos, empanadas, and bowls, plus breakfast and vegetarian options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-3e11-7369-a7f2-b11c7bf5bd69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-3e11-7369-a7f2-b11c7bf5bd69",
        "storage_key": "property/6737460151191769/019e1e26-3e11-7369-a7f2-b11c7bf5bd69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://myvillaverde.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11393768758704810629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "villa-verde-dos",
      "poi_latitude": "35.6072219",
      "poi_longitude": "-77.4115537",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 252-689-6005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_zjl29rprokRhSqLu1HMHp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3ee2da4b-b2f2-4efa-a81d-96ce79b18a2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "The Scullery Coffee House and Creamery",
      "poi_type": "Restaurants",
      "poi_address": "431 Evans St, Greenville, NC 27858, USA",
      "poi_short_description": "Local art-lined spot with seasonal breakfast & lunch dishes, plus a coffee bar & homemade ice cream.",
      "poi_long_description": "Local art-lined spot with seasonal breakfast & lunch dishes, plus a coffee bar & homemade ice cream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-46a8-7673-b2ca-779589c751bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-46a8-7673-b2ca-779589c751bf",
        "storage_key": "property/6737460151191769/019e1e26-46a8-7673-b2ca-779589c751bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.facebook.com/thescullerygreenville",
      "poi_directions_map_url": "https://maps.google.com/?cid=1011907874977761318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-scullery-coffee-house-and-creamery",
      "poi_latitude": "35.6112134",
      "poi_longitude": "-77.3727432",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-321-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b422-737a-97ec-b63faf102418.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b422-737a-97ec-b63faf102418",
        "storage_key": "property/6737460151191769/019e1e26-b422-737a-97ec-b63faf102418.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJp7hyi-PnrokRJkh42dkECw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_13c8348a-7cb4-4d94-b919-706ee4b1089d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Backstage Coffee & Vintage",
      "poi_type": "Restaurants",
      "poi_address": "304 S Greene St, Greenville, NC 27834, USA",
      "poi_short_description": "Colorful neighborhood coffee shop with classic drinks, plus live music, and creative specialty lattes and teas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4686-77cd-b34c-4ca1dbbb04ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4686-77cd-b34c-4ca1dbbb04ff",
        "storage_key": "property/6737460151191769/019e1e26-4686-77cd-b34c-4ca1dbbb04ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://backstagecoffeegvl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16341688810746893360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "backstage-coffee--vintage",
      "poi_latitude": "35.6131463",
      "poi_longitude": "-77.37489579999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-227-0787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b422-737a-97ec-b63faf102418.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b422-737a-97ec-b63faf102418",
        "storage_key": "property/6737460151191769/019e1e26-b422-737a-97ec-b63faf102418.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJX2HsfC_nrokRMFSLMmRXyeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_39a58df3-7534-40aa-89cb-1309b162bd82",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Blackbeard Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "203 E 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "Coffee shop featuring a variety of roasts, plus cookies, teas and muffins.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4323-7551-a3ef-bcadff27cb4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4323-7551-a3ef-bcadff27cb4b",
        "storage_key": "property/6737460151191769/019e1e26-4323-7551-a3ef-bcadff27cb4b.webp",
        "width": 988,
        "height": 1280
      },
      "poi_business_url": "http://www.blackbeardroasters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1139712444383178056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blackbeard-coffee-roasters",
      "poi_latitude": "35.611065",
      "poi_longitude": "-77.37178",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-565-8312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b422-737a-97ec-b63faf102418.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b422-737a-97ec-b63faf102418",
        "storage_key": "property/6737460151191769/019e1e26-b422-737a-97ec-b63faf102418.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJfz2obeTnrokRSC2NAW4S0Q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c41ba9c7-b3d1-44ab-b0b9-45900c117fe6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Parker's Barbecue Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3109 S Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "American BBQ classics like chicken, pork & fried seafood are the draw at this family-run standby.",
      "poi_long_description": "American BBQ classics like chicken, pork & fried seafood are the draw at this family-run standby.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4101-754a-86f2-ac4fa9b33533.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4101-754a-86f2-ac4fa9b33533",
        "storage_key": "property/6737460151191769/019e1e26-4101-754a-86f2-ac4fa9b33533.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://parkersbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3503022007454399888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkers-barbecue-restaurant",
      "poi_latitude": "35.57544439999999",
      "poi_longitude": "-77.39754529999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-756-2388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAXih-8DCrokRkP2xuvQ7nTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_58df6d2a-a04a-483c-a174-76aaae2c5af2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "B's Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "751 State Rd 1204, Greenville, NC 27858, USA",
      "poi_short_description": "Unpretentious BBQ counter-serve joint dishing out smoked chicken, pork & classic side dishes.",
      "poi_long_description": "Unpretentious BBQ counter-serve joint dishing out smoked chicken, pork & classic side dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-3ed6-720c-b59b-09c1662ea414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-3ed6-720c-b59b-09c1662ea414",
        "storage_key": "property/6737460151191769/019e1e26-3ed6-720c-b59b-09c1662ea414.webp",
        "width": 1280,
        "height": 942
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7092134716623739671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bs-barbecue",
      "poi_latitude": "35.6209811",
      "poi_longitude": "-77.4172774",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyqGaTborokRF9uS8_JSbGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_f35037d7-d168-4fb4-8df0-a74bd1ee31e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Jack Brown's Beer & Burger Joint Greenville NC",
      "poi_type": "Restaurants",
      "poi_address": "805 Dickinson Ave, Greenville, NC 27834, USA",
      "poi_short_description": "Bar chain serving creative burgers & a lengthy list of beers in a casual, funky space.",
      "poi_long_description": "Bar chain serving creative burgers & a lengthy list of beers in a casual, funky space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-3cba-751d-8109-6bfe9aec6e7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-3cba-751d-8109-6bfe9aec6e7c",
        "storage_key": "property/6737460151191769/019e1e26-3cba-751d-8109-6bfe9aec6e7c.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.jackbrownsjoint.com/locations/greenville-nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12178145747712768183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-browns-beer--burger-joint-greenville-nc",
      "poi_latitude": "35.6087568",
      "poi_longitude": "-77.3772176",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-689-6827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVZ8EueLnrokRt3ha8wh3Aak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_7e069f16-2f53-4c47-9db8-0842149b9287",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "The Rickhouse",
      "poi_type": "Restaurants",
      "poi_address": "710 Red Banks Rd, Greenville, NC 27858, USA",
      "poi_short_description": "New American fare & a bountiful bourbon collection pair off in an old tobacco storage building.",
      "poi_long_description": "New American fare & a bountiful bourbon collection pair off in an old tobacco storage building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4052-7103-8729-5ccf0aafd133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4052-7103-8729-5ccf0aafd133",
        "storage_key": "property/6737460151191769/019e1e26-4052-7103-8729-5ccf0aafd133.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rickhousegreenvillenc.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3304838939595340240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rickhouse",
      "poi_latitude": "35.5815542",
      "poi_longitude": "-77.36790289999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-689-6377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvWW1Qk_drokR0Hl1eoEl3S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a33edcda-89b7-4b0f-ab87-3e6bc6e385be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Wasabi 88 | Asian Bistro • Sushi • Bar",
      "poi_type": "Restaurants",
      "poi_address": "1605 E Fire Tower Rd, Greenville, NC 27858, USA",
      "poi_short_description": "Casual, contemporary restaurant offering Asian entrees, sushi, cocktails & regular live music.",
      "poi_long_description": "Casual, contemporary restaurant offering Asian entrees, sushi, cocktails & regular live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-3e10-76df-8600-c8076afcc72e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-3e10-76df-8600-c8076afcc72e",
        "storage_key": "property/6737460151191769/019e1e26-3e10-76df-8600-c8076afcc72e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wasabi88.com/?utm_source=google&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=12584368009789988881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wasabi-88--asian-bistro--sushi--bar",
      "poi_latitude": "35.5644194",
      "poi_longitude": "-77.36203619999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-493-0510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTX-OQjvdrokREWBSsgeopK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_5bf6d6f7-cbd5-491d-be3b-718d4d7cc883",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "The Seahorse Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2301a Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Relaxed American eatery serving up breakfast, steaks & seafood, plus beer & wine.",
      "poi_long_description": "Relaxed American eatery serving up breakfast, steaks & seafood, plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4621-708d-89c6-7af9da695b37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4621-708d-89c6-7af9da695b37",
        "storage_key": "property/6737460151191769/019e1e26-4621-708d-89c6-7af9da695b37.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://seahorsesteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5691145686843123607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-seahorse-restaurant",
      "poi_latitude": "35.60429999999999",
      "poi_longitude": "-77.40983299999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 252-758-6958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVEUTliVrokRl-dHZdkC-04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7ec21186-5f8d-4b2e-a056-fca363316957",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Anita's | Authentic Mexican Street Food",
      "poi_type": "Restaurants",
      "poi_address": "1915 N Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "Casual, beloved eatery serving authentic Mexican street food including gorditas and nachos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-48dc-74d6-8b36-609a057df2e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-48dc-74d6-8b36-609a057df2e0",
        "storage_key": "property/6737460151191769/019e1e26-48dc-74d6-8b36-609a057df2e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/anitasmexicanrestaurant1915/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17486561146065770672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anitas--authentic-mexican-street-food",
      "poi_latitude": "35.6438442",
      "poi_longitude": "-77.3701486",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-375-7925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpc6IMSzmrokRsNhl7ra-rPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_63c0871a-149c-4f94-a9bf-f225c1b01397",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Hook & Reel Cajun Seafood & Bar",
      "poi_type": "Restaurants",
      "poi_address": "500 Greenville Blvd SE, Greenville, NC 27834, USA",
      "poi_short_description": "Seafood restaurant chain serving shrimp and crab legs in cajun-style boil bags.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4b95-731b-a93a-4aafb73cb329.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4b95-731b-a93a-4aafb73cb329",
        "storage_key": "property/6737460151191769/019e1e26-4b95-731b-a93a-4aafb73cb329.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hookreel.com/location/greenville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9457822116883766179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hook--reel-cajun-seafood--bar",
      "poi_latitude": "35.5743207",
      "poi_longitude": "-77.3943819",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-364-2368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzT6rkrLDrokRo5uwCRvvQIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_8ba4bb86-cb7d-42b5-bffd-1f2a8e5103d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Angus Grill",
      "poi_type": "Restaurants",
      "poi_address": "201 S Jarvis St, Greenville, NC 27858, USA",
      "poi_short_description": "Burgers and fries are the focus at this casual spot, which also serves sandwiches, salads and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-52bb-732d-87cc-b4fb70a6acf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-52bb-732d-87cc-b4fb70a6acf7",
        "storage_key": "property/6737460151191769/019e1e26-52bb-732d-87cc-b4fb70a6acf7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.angusgrillnc.com/?utm_source=rsd&utm_medium=gmb&utm_campaign=brandawareness&utm_content=southjarvis",
      "poi_directions_map_url": "https://maps.google.com/?cid=13514158559417093548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "angus-grill",
      "poi_latitude": "35.6124034",
      "poi_longitude": "-77.3654968",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-689-6460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9WFwYLnrokRrE1c1Jvvi7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3a003275-f086-406f-87d0-5a9992817222",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Ernie's Famous Subs",
      "poi_type": "Restaurants",
      "poi_address": "911 S Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "Local sandwich shop known for its peppersteak subs and oven-toasted offerings since 1980.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-510f-762f-9151-641a660185f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-510f-762f-9151-641a660185f1",
        "storage_key": "property/6737460151191769/019e1e26-510f-762f-9151-641a660185f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=161544476737339441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernies-famous-subs",
      "poi_latitude": "35.60277",
      "poi_longitude": "-77.3961443",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-752-4388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39e2-703e-914c-858db9b2b9d8",
        "storage_key": "property/6737460151191769/019e1e24-39e2-703e-914c-858db9b2b9d8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYaR7mR7orokRMQBbf9jrPQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_a8ca4da0-288b-4045-b116-0622b1b69418",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Tropicana Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1204 N Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "Grocery store offering bulk foods and organic products, as well as country meats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4bbb-72d3-b867-d53c4fe9a99b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4bbb-72d3-b867-d53c4fe9a99b",
        "storage_key": "property/6737460151191769/019e1e26-4bbb-72d3-b867-d53c4fe9a99b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tropicananc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11246031181225134288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropicana-supermarket",
      "poi_latitude": "35.63166",
      "poi_longitude": "-77.37785149999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-329-2929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39fe-7671-a08a-d5ebcbe82d9f",
        "storage_key": "property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8m11tfnrokR0AjkecbtEZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b3daca2d-653e-4882-91c3-c930c40cd790",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Piggly Wiggly",
      "poi_type": "Shopping & Retail",
      "poi_address": "2105 Dickinson Ave, Greenville, NC 27834, USA",
      "poi_short_description": "Supermarket chain selling groceries such as organic products, and offering check cashing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-4ed5-721d-a1d6-49a02e9435aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-4ed5-721d-a1d6-49a02e9435aa",
        "storage_key": "property/6737460151191769/019e1e26-4ed5-721d-a1d6-49a02e9435aa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pigglywigglystores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2334567404282428543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piggly-wiggly",
      "poi_latitude": "35.599596",
      "poi_longitude": "-77.3919598",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-756-3791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39fe-7671-a08a-d5ebcbe82d9f",
        "storage_key": "property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgXqCch3orokRf7x1ZK8MZiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_daf6cfdc-0298-4e33-9a52-1ca72463f56d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "The Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "950 Criswell Dr #111, Greenville, NC 27834, USA",
      "poi_short_description": "Upscale grocery store chain with an old-world vibe offers local produce, prepared eats, wine & more.",
      "poi_long_description": "Upscale grocery store chain with an old-world vibe offers local produce, prepared eats, wine & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5110-76d9-975f-b1957bbf1a6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5110-76d9-975f-b1957bbf1a6c",
        "storage_key": "property/6737460151191769/019e1e26-5110-76d9-975f-b1957bbf1a6c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.thefreshmarket.com/nc/greenville/101",
      "poi_directions_map_url": "https://maps.google.com/?cid=390920840999453421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-fresh-market",
      "poi_latitude": "35.5666",
      "poi_longitude": "-77.406183",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-756-6210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39fe-7671-a08a-d5ebcbe82d9f",
        "storage_key": "property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcdu-bObCrokR7cIRB2_UbAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d9d4375d-da0c-4605-8153-43d6855f0c94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 Evans St, Greenville, NC 27834, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5630-76bb-9db0-688d066b5f19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5630-76bb-9db0-688d066b5f19",
        "storage_key": "property/6737460151191769/019e1e26-5630-76bb-9db0-688d066b5f19.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/nc/greenville/university-commons/097/00362?cid=loc_09700362_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15303347213691114928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "35.5811233",
      "poi_longitude": "-77.3830566",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-353-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39fe-7671-a08a-d5ebcbe82d9f",
        "storage_key": "property/6737460151191769/019e1e24-39fe-7671-a08a-d5ebcbe82d9f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4yfcrTCrokRsNWF0jVpYNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3ad782d8-d711-4363-bca2-05d5b2f7b4d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "210 Greenville Blvd SW, Greenville, NC 27834, USA",
      "poi_short_description": "Retail giant stocking grocery store items, toys, clothing, electronics, home goods, furniture and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5642-77b6-8838-f2512e434d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5642-77b6-8838-f2512e434d0c",
        "storage_key": "property/6737460151191769/019e1e26-5642-77b6-8838-f2512e434d0c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1379-greenville-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11688352857176849568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.5774237",
      "poi_longitude": "-77.3875071",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-355-2441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39f5-730d-92f3-d6c3ed173d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39f5-730d-92f3-d6c3ed173d34",
        "storage_key": "property/6737460151191769/019e1e24-39f5-730d-92f3-d6c3ed173d34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgaXB57fCrokRoLxy_f5eNaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_edda3b2c-1932-4e24-86d9-6bfd37ecec85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "704 S Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-53e0-774d-8a79-689d8910e4cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-53e0-774d-8a79-689d8910e4cf",
        "storage_key": "property/6737460151191769/019e1e26-53e0-774d-8a79-689d8910e4cf.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/greenville-nc-pharmacies/704-so-memorial-dr-greenville-nc-27834/storeid=3385?WT.mc_id=LS_GOOGLE_RX_3385",
      "poi_directions_map_url": "https://maps.google.com/?cid=15264264211538715707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.6068698",
      "poi_longitude": "-77.39584769999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 252-758-4104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b42c-753a-bc0f-44a046c0f7b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b42c-753a-bc0f-44a046c0f7b5",
        "storage_key": "property/6737460151191769/019e1e26-b42c-753a-bc0f-44a046c0f7b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4NY_xDorokROyR5Rm2P1dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_b4da06be-647f-4b03-9053-c9ddf5939b3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 Evans St, Greenville, NC 27834, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5649-7268-8c9c-cbf3caed9b2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5649-7268-8c9c-cbf3caed9b2f",
        "storage_key": "property/6737460151191769/019e1e26-5649-7268-8c9c-cbf3caed9b2f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/greenville/1022",
      "poi_directions_map_url": "https://maps.google.com/?cid=10385686962230836328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.5790193",
      "poi_longitude": "-77.38359679999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-355-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39f5-730d-92f3-d6c3ed173d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39f5-730d-92f3-d6c3ed173d34",
        "storage_key": "property/6737460151191769/019e1e24-39f5-730d-92f3-d6c3ed173d34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyx52WLTCrokRaLwsNERfIZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ddb5e4ef-df0d-4390-8d66-0187a6f5c13f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Greenville Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "714 Greenville Blvd SE, Greenville, NC 27858, USA",
      "poi_short_description": "Long-standing enclosed shopping center featuring 58 stores & restaurants under 1 roof.",
      "poi_long_description": "Long-standing enclosed shopping center featuring 58 stores & restaurants under 1 roof.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e23-f412-754e-842c-c51b4d95c0ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e23-f412-754e-842c-c51b4d95c0ac",
        "storage_key": "property/6737460151191769/019e1e23-f412-754e-842c-c51b4d95c0ac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thegreenvillemall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5262191077716969931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-mall",
      "poi_latitude": "35.5860817",
      "poi_longitude": "-77.3677381",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-756-5234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39f5-730d-92f3-d6c3ed173d34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39f5-730d-92f3-d6c3ed173d34",
        "storage_key": "property/6737460151191769/019e1e24-39f5-730d-92f3-d6c3ed173d34.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf6nDblDdrokRy8mMp-cOB0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4692f3f4-d2da-4042-9125-d1c805d95c0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1301 W Arlington Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-59a2-71d9-84b3-297dd09258e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-59a2-71d9-84b3-297dd09258e5",
        "storage_key": "property/6737460151191769/019e1e26-59a2-71d9-84b3-297dd09258e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/greenville/1301-arlington-blvd/2723104?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15108621985061233504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "35.5910913",
      "poi_longitude": "-77.3963144",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-321-0364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b424-76c9-a77a-791fb6d1dbc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b424-76c9-a77a-791fb6d1dbc9",
        "storage_key": "property/6737460151191769/019e1e26-b424-76c9-a77a-791fb6d1dbc9.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJFV6JhKPCrokRYGM7gaWbrNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7fa0f436-1498-42f7-9e5d-ff953ffee119",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "East Carolina University",
      "poi_type": "Education",
      "poi_address": "E 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e23-fb1c-752c-932d-47c3043542af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e23-fb1c-752c-932d-47c3043542af",
        "storage_key": "property/6737460151191769/019e1e23-fb1c-752c-932d-47c3043542af.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "https://www.ecu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5924483534454368571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-carolina-university",
      "poi_latitude": "35.6068806",
      "poi_longitude": "-77.3665364",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-328-6131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBxZ44pbnrokRO6nNpGL-N1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_24719d8d-e1b2-42ba-9501-e2e89dfc4be7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Pitt Community College",
      "poi_type": "Education",
      "poi_address": "1986 Pitt Tech Rd, Winterville, NC 28590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e23-fdfc-767c-9b26-517ee9e85df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e23-fdfc-767c-9b26-517ee9e85df2",
        "storage_key": "property/6737460151191769/019e1e23-fdfc-767c-9b26-517ee9e85df2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pittcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13604648377313597505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-community-college",
      "poi_latitude": "35.5495599",
      "poi_longitude": "-77.4068149",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-493-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3Uc-zubCrokRQRjfX55rzbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_978b5963-7571-4875-ad4f-8bd458115d39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "The Oakwood School",
      "poi_type": "Education",
      "poi_address": "4000 MacGregor Downs Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-a9ab-7367-9e55-454541c58353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-a9ab-7367-9e55-454541c58353",
        "storage_key": "property/6737460151191769/019e1e26-a9ab-7367-9e55-454541c58353.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.theoakwoodschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10234258172823721244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-oakwood-school",
      "poi_latitude": "35.6217845",
      "poi_longitude": "-77.4479537",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-931-0760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9JAcurprokRHNXLspVjB44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4c6814bb-38a9-407c-97d6-7270d13f5aba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "J.H. Rose High School",
      "poi_type": "Education",
      "poi_address": "600 W Arlington Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-595f-770b-aeb9-653a06373f83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-595f-770b-aeb9-653a06373f83",
        "storage_key": "property/6737460151191769/019e1e26-595f-770b-aeb9-653a06373f83.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.pitt.k12.nc.us/jhr",
      "poi_directions_map_url": "https://maps.google.com/?cid=2235126104135116370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jh-rose-high-school",
      "poi_latitude": "35.593733",
      "poi_longitude": "-77.3841279",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-321-3640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj7VwVKnCrokRUiYteVnDBB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_aa2250e0-49cd-46d6-a23e-be5b59514fc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "D.H. Conley High School",
      "poi_type": "Education",
      "poi_address": "2006 Worthington Rd, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5a29-759d-b74d-ca73ac75a467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5a29-759d-b74d-ca73ac75a467",
        "storage_key": "property/6737460151191769/019e1e26-5a29-759d-b74d-ca73ac75a467.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.pitt.k12.nc.us/dhc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1509483648374872885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dh-conley-high-school",
      "poi_latitude": "35.5303639",
      "poi_longitude": "-77.3247248",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 252-756-3440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb-B7WlzcrokRNRulb2HD8hQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_440262c0-627f-4b6d-a88e-f1416502e280",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "South Central High School",
      "poi_type": "Education",
      "poi_address": "570 Forlines Rd, Winterville, NC 28590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5c64-741a-9533-591f360c3dfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5c64-741a-9533-591f360c3dfd",
        "storage_key": "property/6737460151191769/019e1e26-5c64-741a-9533-591f360c3dfd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pitt.k12.nc.us/schs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13475331752653991778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-central-high-school",
      "poi_latitude": "35.5415155",
      "poi_longitude": "-77.42862579999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-321-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjbeTXKHDrokRYq97a9X-Abs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2db4aa9d-04f2-4730-a8ef-07ef0058aeae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "South Greenville Elementary School",
      "poi_type": "Education",
      "poi_address": "811 Howell St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pitt.k12.nc.us/southgreenville",
      "poi_directions_map_url": "https://maps.google.com/?cid=9802923912455596401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-greenville-elementary-school",
      "poi_latitude": "35.5984082",
      "poi_longitude": "-77.3845879",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-756-7004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNzejdALorokRcSkZOlz7Cog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_08d6be47-04ce-4f42-bdac-5cbf4a916681",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Lakeforest Elementary School",
      "poi_type": "Education",
      "poi_address": "3300 Briarcliff Dr, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pitt.k12.nc.us/lakeforest",
      "poi_directions_map_url": "https://maps.google.com/?cid=8449136913806111067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeforest-elementary-school",
      "poi_latitude": "35.5923311",
      "poi_longitude": "-77.4213407",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-756-3941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaxZdNobCrokRW7EN9kFdQXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2474a424-4cd8-42ac-a35d-e9dfea56cfd2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Belvoir Elementary School",
      "poi_type": "Education",
      "poi_address": "2568 NC-33, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://pitt.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16289268009458406260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belvoir-elementary-school",
      "poi_latitude": "35.6674035",
      "poi_longitude": "-77.41797199999999",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-752-6365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu4xxyd3orokRdBPnSvMaD-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_22682b23-862f-4580-ae4f-5b30e587153d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Stantonsburg KinderCare",
      "poi_type": "Education",
      "poi_address": "2263 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5cd7-73f8-bbe3-5511f4880b07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5cd7-73f8-bbe3-5511f4880b07",
        "storage_key": "property/6737460151191769/019e1e26-5cd7-73f8-bbe3-5511f4880b07.webp",
        "width": 933,
        "height": 700
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/greenville/nc/301041?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3NTYwLTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=13022808406708514951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stantonsburg-kindercare",
      "poi_latitude": "35.60453150000001",
      "poi_longitude": "-77.4067123",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 252-752-0094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI3eWUyHorokRh_DUgz9PurQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_6111ff8f-b3c9-4fd1-831c-1a1f8c6877b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Golden Ticket Greenville Grande IMAX + Elite",
      "poi_type": "Entertainment",
      "poi_address": "750 Greenville Blvd SW, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5d86-75cb-bc7c-61ce78306e9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5d86-75cb-bc7c-61ce78306e9a",
        "storage_key": "property/6737460151191769/019e1e26-5d86-75cb-bc7c-61ce78306e9a.webp",
        "width": 1280,
        "height": 499
      },
      "poi_business_url": "https://www.gtcinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6832701772143224310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-ticket-greenville-grande-imax--elite",
      "poi_latitude": "35.57314180000001",
      "poi_longitude": "-77.4043896",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-321-0496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b430-713b-87e0-25d7fab72674.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b430-713b-87e0-25d7fab72674",
        "storage_key": "property/6737460151191769/019e1e26-b430-713b-87e0-25d7fab72674.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2I3x7HDrokR9mXHgA-i0l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_fe7596be-8ebc-4f42-8917-7f9461565a27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "AMC Fire Tower 12",
      "poi_type": "Entertainment",
      "poi_address": "1685 E Fire Tower Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5d8c-732b-a7df-e0dbed09ab4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5d8c-732b-a7df-e0dbed09ab4e",
        "storage_key": "property/6737460151191769/019e1e26-5d8c-732b-a7df-e0dbed09ab4e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/greenville-nc/amc-fire-tower-12?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17393828229078499113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-fire-tower-12",
      "poi_latitude": "35.5664768",
      "poi_longitude": "-77.3612586",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 252-353-4991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b430-713b-87e0-25d7fab72674.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b430-713b-87e0-25d7fab72674",
        "storage_key": "property/6737460151191769/019e1e26-b430-713b-87e0-25d7fab72674.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUE7hzvdrokRKb9iLp5KY_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a378ab6e-7f8f-4165-96bc-9e9283cfe47c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Greenville Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "802 Evans St, Greenville, NC 27834, USA",
      "poi_short_description": "Free museum building featuring local, regional and national art exhibits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-02f8-77c8-9559-d33fa4159c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-02f8-77c8-9559-d33fa4159c4e",
        "storage_key": "property/6737460151191769/019e1e24-02f8-77c8-9559-d33fa4159c4e.webp",
        "width": 800,
        "height": 449
      },
      "poi_business_url": "https://www.gmoa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2609222515371182819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-museum-of-art",
      "poi_latitude": "35.6079879",
      "poi_longitude": "-77.3741574",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-758-1946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3b23-72f0-a66f-10bca63f0aba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3b23-72f0-a66f-10bca63f0aba",
        "storage_key": "property/6737460151191769/019e1e24-3b23-72f0-a66f-10bca63f0aba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0-1N-PnrokR44qmsA3SNSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2f357f3f-d218-4d10-9b0b-5dd1df84ca14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "North Carolina Museum of Natural Sciences at Greenville and Contentnea Creek",
      "poi_type": "Entertainment",
      "poi_address": "226 W 8th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-001d-75fb-a341-582c304e5ee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-001d-75fb-a341-582c304e5ee1",
        "storage_key": "property/6737460151191769/019e1e24-001d-75fb-a341-582c304e5ee1.webp",
        "width": 1199,
        "height": 899
      },
      "poi_business_url": "https://atimeforscience.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9985511395728940246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-carolina-museum-of-natural-sciences-at-greenville-and-contentnea-creek",
      "poi_latitude": "35.6084015",
      "poi_longitude": "-77.3754267",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-364-2862",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3b23-72f0-a66f-10bca63f0aba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3b23-72f0-a66f-10bca63f0aba",
        "storage_key": "property/6737460151191769/019e1e24-3b23-72f0-a66f-10bca63f0aba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZEgPr3CrokR1twJe7Wpk4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a16c76d2-b177-469f-9006-dc1128e9d3ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Williams Arena",
      "poi_type": "Entertainment",
      "poi_address": "200 Ficklen Dr, Greenville, NC 27858, USA",
      "poi_short_description": "Venue at Minges Coliseum hosting athletic competitions, concerts, and events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-62c1-7625-ae7f-0db6e8c47c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-62c1-7625-ae7f-0db6e8c47c25",
        "storage_key": "property/6737460151191769/019e1e26-62c1-7625-ae7f-0db6e8c47c25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ecupirates.com/facilities/?id=12",
      "poi_directions_map_url": "https://maps.google.com/?cid=1574864445632210706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williams-arena",
      "poi_latitude": "35.5974775",
      "poi_longitude": "-77.3669814",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-737-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_s0IvjnrokREudMi94K2xU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_12701b8e-d851-475b-9e74-7862f7338562",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Greenville Toyota Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "105 E 1st St, Greenville, NC 27858, USA",
      "poi_short_description": "Stage suitable for concerts and other performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-61f7-705a-942e-e7fc389de1b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-61f7-705a-942e-e7fc389de1b2",
        "storage_key": "property/6737460151191769/019e1e26-61f7-705a-942e-e7fc389de1b2.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=108866583846226813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-toyota-amphitheater",
      "poi_latitude": "35.6161525",
      "poi_longitude": "-77.37017089999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ04cIDOfnrokRfYsQypTFggE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_4f13215e-be75-462d-b685-5a5b90a14448",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Emerge Gallery & Art Center",
      "poi_type": "Entertainment",
      "poi_address": "404 Evans St, Greenville, NC 27858, USA",
      "poi_short_description": "Nonprofit organization with art galleries, classes, pottery studios and summer camps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-60d7-75c5-8f1a-ddc12fc98637.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-60d7-75c5-8f1a-ddc12fc98637",
        "storage_key": "property/6737460151191769/019e1e26-60d7-75c5-8f1a-ddc12fc98637.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.emergegallery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17110577991267321663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerge-gallery--art-center",
      "poi_latitude": "35.6119814",
      "poi_longitude": "-77.3730308",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-551-6947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyV49-PnrokRPwcb_wb8dO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_2a4fb227-d242-4459-b5cf-e95ea9ecbb4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Uptown Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "418 Evans St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-62ce-7269-8155-96b16aeb806c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-62ce-7269-8155-96b16aeb806c",
        "storage_key": "property/6737460151191769/019e1e26-62ce-7269-8155-96b16aeb806c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.uptownbeers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4999421339946570654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-brewing-company",
      "poi_latitude": "35.611488",
      "poi_longitude": "-77.373291",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-689-6487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFfDs8uPnrokRntMFejiDYUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_392d8083-bda7-45e1-9609-f076d2e75f54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Pitt Street Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "630 S Pitt St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-6a33-74f6-a3d2-662f34d614f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-6a33-74f6-a3d2-662f34d614f7",
        "storage_key": "property/6737460151191769/019e1e26-6a33-74f6-a3d2-662f34d614f7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pittstreetbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15729044209721479871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-street-brewing-company",
      "poi_latitude": "35.609393",
      "poi_longitude": "-77.37712739999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-227-4151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWlilOLnrokRvxLdaF_KSNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_4d3f23ca-58ed-4820-bdf1-45def5e0d701",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "5th Street Hardware Restaurant and Taproom",
      "poi_type": "Entertainment",
      "poi_address": "120 W 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "Warm, brick-lined tavern offering 40+ taps of craft beers, hearty pub fare & a convivial ambiance.",
      "poi_long_description": "Warm, brick-lined tavern offering 40+ taps of craft beers, hearty pub fare & a convivial ambiance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-68f9-7578-a490-119188aa2d01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-68f9-7578-a490-119188aa2d01",
        "storage_key": "property/6737460151191769/019e1e26-68f9-7578-a490-119188aa2d01.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.5thstreethardware.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17678496593020478316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "5th-street-hardware-restaurant-and-taproom",
      "poi_latitude": "35.611557",
      "poi_longitude": "-77.3737929",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-364-8921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b43d-772d-9dcc-8ec34bc8b927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b43d-772d-9dcc-8ec34bc8b927",
        "storage_key": "property/6737460151191769/019e1e26-b43d-772d-9dcc-8ec34bc8b927.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTiJlOPnrokRbGPwlfyiVvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_880913de-709e-44c5-89f3-de3d12cf18b4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "ECU Health Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2100 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-1025-769a-8820-3802602d9834.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-1025-769a-8820-3802602d9834",
        "storage_key": "property/6737460151191769/019e1e24-1025-769a-8820-3802602d9834.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://locations.ecuhealth.org/Details/163",
      "poi_directions_map_url": "https://maps.google.com/?cid=4684740979372181751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-health-medical-center",
      "poi_latitude": "35.6082626",
      "poi_longitude": "-77.4014852",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 252-847-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-399b-7707-b94c-6e97619bce02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-399b-7707-b94c-6e97619bce02",
        "storage_key": "property/6737460151191769/019e1e24-399b-7707-b94c-6e97619bce02.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz40sCPorokR98gxlBmLA0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_af619950-3d14-4831-8cda-8c02ac502aec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "FastMed Urgent Care Greenville",
      "poi_type": "Health and Wellness",
      "poi_address": "315 Greenville Blvd SE #100, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-65cc-75df-ac6a-167deff36b2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-65cc-75df-ac6a-167deff36b2f",
        "storage_key": "property/6737460151191769/019e1e26-65cc-75df-ac6a-167deff36b2f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fastmed.com/urgent-care-centers/greenville-nc-walk-in-clinic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813048986963193927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fastmed-urgent-care-greenville",
      "poi_latitude": "35.5814722",
      "poi_longitude": "-77.37739220000002",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-917-5621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7eLWmEzdrokRR7Aua_nyU-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_99f6f8c5-1c01-4171-8689-327be401962c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Physicians East Urgent Care Center & Sleep Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1711 E Arlington Blvd, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-6435-770c-8125-1f172854714d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-6435-770c-8125-1f172854714d",
        "storage_key": "property/6737460151191769/019e1e26-6435-770c-8125-1f172854714d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.physicianseast.com/?utm_source=Google&utm_medium=Yext&y_source=1_MTU3OTc5MDAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10980209703047371364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "physicians-east-urgent-care-center--sleep-center",
      "poi_latitude": "35.5689099",
      "poi_longitude": "-77.3563547",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 252-355-4357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zPQFj7drokRZJpvnYyKYZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_40662f0c-b488-486e-bcbc-d27e771fae33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "671 S Memorial Dr Walgreens, Greenville, NC 27834, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-5837-75bb-befe-f2b82a593638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-5837-75bb-befe-f2b82a593638",
        "storage_key": "property/6737460151191769/019e1e26-5837-75bb-befe-f2b82a593638.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-671+s+memorial+dr-greenville-nc-27834/id=6579",
      "poi_directions_map_url": "https://maps.google.com/?cid=5579043469898320776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.6088784",
      "poi_longitude": "-77.393847",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-754-2099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1exnDRrorokRiIvAEXq-bE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_97dfd9cf-a065-427a-aec5-dabecf12f449",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "210 Greenville Blvd SW, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-69d2-700e-9782-38777e4731a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-69d2-700e-9782-38777e4731a1",
        "storage_key": "property/6737460151191769/019e1e26-69d2-700e-9782-38777e4731a1.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1379-greenville-nc/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1813695741840706556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.5774237",
      "poi_longitude": "-77.3875071",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-355-3001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b42c-753a-bc0f-44a046c0f7b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b42c-753a-bc0f-44a046c0f7b5",
        "storage_key": "property/6737460151191769/019e1e26-b42c-753a-bc0f-44a046c0f7b5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgaXB57fCrokR_MsN96qKKxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_24da6bbb-a2eb-47cd-9959-1f6b28da0d6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "ECU Eakin Student Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "128 E 7th St, Greenville, NC 27858, USA",
      "poi_short_description": "Clean recreational facility featuring an indoor track and weight rooms, plus yoga and basketball areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-6cdc-7209-902c-4aa699ff3d28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-6cdc-7209-902c-4aa699ff3d28",
        "storage_key": "property/6737460151191769/019e1e26-6cdc-7209-902c-4aa699ff3d28.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://crw.ecu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8415261454893037734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-eakin-student-recreation-center",
      "poi_latitude": "35.6078275",
      "poi_longitude": "-77.3708533",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-328-6387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8MpyOTnrokRprjvDrUDyXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_dbbb44a2-fc4c-4e40-8bd2-9770ddf0afc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "CrossFit Greenville",
      "poi_type": "Health and Wellness",
      "poi_address": "818 Clark St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-6a6c-755f-bf5e-49174696e347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-6a6c-755f-bf5e-49174696e347",
        "storage_key": "property/6737460151191769/019e1e26-6a6c-755f-bf5e-49174696e347.webp",
        "width": 960,
        "height": 687
      },
      "poi_business_url": "http://crossfitgreenville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2960201479779844414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-greenville",
      "poi_latitude": "35.608591",
      "poi_longitude": "-77.37844199999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-756-4790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJayrnOqnCrokRPgHd4Y-_FCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b208a596-f958-43e4-88bb-be4218cfd29e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Yoga Strong Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "425 Greenville Blvd SE, Greenville, NC 27858, USA",
      "poi_short_description": "Studio offering classes, including yoga for beginners, plus massages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-6d44-725e-ae1f-f5591c7bef31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-6d44-725e-ae1f-f5591c7bef31",
        "storage_key": "property/6737460151191769/019e1e26-6d44-725e-ae1f-f5591c7bef31.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.yogastrongnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750933569522833267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-strong-studio",
      "poi_latitude": "35.5829065",
      "poi_longitude": "-77.37538959999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-347-2516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJajEmlDdrokRcxfLfO3Xtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_22cb1f1c-a9ce-4a24-8120-6d9c06fe1af0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "518 Greenville Blvd SE D, Greenville, NC 27858, USA",
      "poi_short_description": "Chain fitness studio offering group workouts that combine cardio and strength training with real-time tracking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-717b-7670-98e5-89e345a5084d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-717b-7670-98e5-89e345a5084d",
        "storage_key": "property/6737460151191769/019e1e26-717b-7670-98e5-89e345a5084d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/greenville-north-carolina-1184?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=8652512710829327484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.5821232",
      "poi_longitude": "-77.37315079999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-689-8428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl9_W-hLdrokRfMSIr3fmE3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8dbd148d-1b38-47ca-b779-0c391e5d502b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "River Park North",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Mumford Rd, Greenville, NC 27834, USA",
      "poi_short_description": "324-acre parkland offering 5 fishing ponds, 2 piers, campsites, boat rentals, trails & picnic areas.",
      "poi_long_description": "324-acre parkland offering 5 fishing ponds, 2 piers, campsites, boat rentals, trails & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-1396-76ee-9682-59c046867f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-1396-76ee-9682-59c046867f5c",
        "storage_key": "property/6737460151191769/019e1e24-1396-76ee-9682-59c046867f5c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.greenvillenc.gov/government/recreation-parks/river-park-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=13168882477249410174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-park-north",
      "poi_latitude": "35.6280096",
      "poi_longitude": "-77.35975239999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-329-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY7i2Q8jnrokRfjRRYddEwbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e51065d6-21d6-4508-b3ae-041cb494479c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Wildwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3450 Blue Heron Dr, Greenville, NC 27834, USA",
      "poi_short_description": "New park offering kayaking, trails and boating, plus playground equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-141f-7129-92d9-2248e8d8143f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-141f-7129-92d9-2248e8d8143f",
        "storage_key": "property/6737460151191769/019e1e24-141f-7129-92d9-2248e8d8143f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillenc.gov/Facilities/Facility/Details/Wildwood-Park-44",
      "poi_directions_map_url": "https://maps.google.com/?cid=16635169238969805013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildwood-park",
      "poi_latitude": "35.6144646",
      "poi_longitude": "-77.3221162",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 252-329-4789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9BErv7nrokR1ehMM0n-2-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cbd44b74-436f-4e90-8e6b-4ae818aaf968",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Town Common",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 E 1st St, Greenville, NC 27858, USA",
      "poi_short_description": "City park with a modern playground, riverfront esplanade, open-air amphitheater & boat ramp.",
      "poi_long_description": "City park with a modern playground, riverfront esplanade, open-air amphitheater & boat ramp.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-17f1-74d1-9591-cfbcf6cae882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-17f1-74d1-9591-cfbcf6cae882",
        "storage_key": "property/6737460151191769/019e1e24-17f1-74d1-9591-cfbcf6cae882.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/62/251?npage=4",
      "poi_directions_map_url": "https://maps.google.com/?cid=11698650257115329890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-common",
      "poi_latitude": "35.6152917",
      "poi_longitude": "-77.36927779999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_hjIufnrokRYjXkPm30WaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6f47b4c9-d2ad-4b3a-b27c-fbf4e9e9a7b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Greensprings Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 E 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-7243-772b-8663-c4019f39e75c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-7243-772b-8663-c4019f39e75c",
        "storage_key": "property/6737460151191769/019e1e26-7243-772b-8663-c4019f39e75c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/20/251?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=13321115421044859403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greensprings-park",
      "poi_latitude": "35.6053757",
      "poi_longitude": "-77.3437448",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJReAcnUjnrokRC2Jbq-Ub3rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_48d52d16-5ae3-4af7-8089-bcf313ec7fd5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Elm Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1055 S Elm St, Greenville, NC 27858, USA",
      "poi_short_description": "Expansive community park boasting a lighted youth ball field, tennis courts & picnic areas.",
      "poi_long_description": "Expansive community park boasting a lighted youth ball field, tennis courts & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-1743-7312-ae5a-dbf617b7b534.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-1743-7312-ae5a-dbf617b7b534",
        "storage_key": "property/6737460151191769/019e1e24-1743-7312-ae5a-dbf617b7b534.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greenvillenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10184049553228629806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elm-street-park",
      "poi_latitude": "35.6010292",
      "poi_longitude": "-77.358538",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-329-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGypsXYLnrokRLgcrexwDVY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a41882b3-e8eb-48ba-8d58-c25e0caaf634",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "West Meadowbrook Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Legion St, Greenville, NC 27834, USA",
      "poi_short_description": "Relaxed park with a baseball field, a playground, and a disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-73f5-742e-a5e7-529ae9d4a871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-73f5-742e-a5e7-529ae9d4a871",
        "storage_key": "property/6737460151191769/019e1e26-73f5-742e-a5e7-529ae9d4a871.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/63",
      "poi_directions_map_url": "https://maps.google.com/?cid=2569492675014227142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-meadowbrook-park",
      "poi_latitude": "35.6274259",
      "poi_longitude": "-77.37708669999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwbDY9jnrokRxvQwY_mrqCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_78f0af53-7346-45d5-976e-d13b28c3b26e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "South Greenville Rec Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "851 Howell St, Greenville, NC 27834, USA",
      "poi_short_description": "Park with amenities including a basketball court for recreation.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-750d-711c-8f60-9a2db500244e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-750d-711c-8f60-9a2db500244e",
        "storage_key": "property/6737460151191769/019e1e26-750d-711c-8f60-9a2db500244e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greenvillenc.gov/government/recreation-parks/programs-and-activities/south-greenville-recreation-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11333363191506754892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-greenville-rec-center",
      "poi_latitude": "35.598764",
      "poi_longitude": "-77.38609559999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-329-4549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZyfxaALorokRTF0_pMYxSJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_d38c8d76-17a2-4939-b23b-ca66e10cbb47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Pitt County Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "403 Government Cir, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-7969-711b-bbda-630592a16aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-7969-711b-bbda-630592a16aee",
        "storage_key": "property/6737460151191769/019e1e26-7969-711b-bbda-630592a16aee.webp",
        "width": 939,
        "height": 704
      },
      "poi_business_url": "https://pittcountyarboretum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11546036881305306421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-county-arboretum",
      "poi_latitude": "35.639625",
      "poi_longitude": "-77.360575",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-902-1701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj38wU8vnrokRNQXDuV7DO6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_89be7b4a-a51b-4a43-8e17-e148b5e1fadf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Peppermint Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Brownlea Dr, Greenville, NC 27858, USA",
      "poi_short_description": "Dog-friendly, kid-friendly park featuring a playground with swings and slides as well as a pickleball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-7b4c-7227-86ea-e41c30d29723.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-7b4c-7227-86ea-e41c30d29723",
        "storage_key": "property/6737460151191769/019e1e26-7b4c-7227-86ea-e41c30d29723.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/28/251?sortn=FCAddress&sortd=asc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14598109181998799946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peppermint-park",
      "poi_latitude": "35.5928215",
      "poi_longitude": "-77.3521988",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjW6htWHdrokRShxo-fTmlso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b4ef669f-637b-43d2-bcf9-1dd4e8fa2252",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Greenville Offleash Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 N Ash St, Greenville, NC 27858, USA",
      "poi_short_description": "Large grassy area for dogs to run and play, with picnic tables and a water spigot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-756d-7788-bfc4-0e2268dd0122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-756d-7788-bfc4-0e2268dd0122",
        "storage_key": "property/6737460151191769/019e1e26-756d-7788-bfc4-0e2268dd0122.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/54/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5418804516701890816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-offleash-dog-park",
      "poi_latitude": "35.6134922",
      "poi_longitude": "-77.3550589",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3acf-753a-8616-ac0021836a77",
        "storage_key": "property/6737460151191769/019e1e24-3acf-753a-8616-ac0021836a77.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfy58I5XnrokRAGlMdf91M0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_b5b8c9f4-8916-4e58-bb1c-aaa5abc34068",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "G.K. Butterfield Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "600 S Pitt St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-74a5-7062-bfef-aaa360eb66a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-74a5-7062-bfef-aaa360eb66a4",
        "storage_key": "property/6737460151191769/019e1e26-74a5-7062-bfef-aaa360eb66a4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greenvillenc.gov/government/public-works/major-projects/g-k-butterfield-transportation-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3298844270051507652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gk-butterfield-transportation-center",
      "poi_latitude": "35.6107129",
      "poi_longitude": "-77.37669799999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-329-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLe1EevjnrokRxL3AtWLZxy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_5ba28443-21f8-464a-8c13-37c36bcd5c7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Pitt-Greenville Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 Airport Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-192e-768d-b29e-344e2181164e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-192e-768d-b29e-344e2181164e",
        "storage_key": "property/6737460151191769/019e1e24-192e-768d-b29e-344e2181164e.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.flypgv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6646301192363862710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-greenville-airport",
      "poi_latitude": "35.6338958",
      "poi_longitude": "-77.3812179",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-902-2025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-42e1-713e-ae3f-ef56fa2cac8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-42e1-713e-ae3f-ef56fa2cac8a",
        "storage_key": "property/6737460151191769/019e1e24-42e1-713e-ae3f-ef56fa2cac8a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yAKN9bnrokRtmoaibhnPFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_61555faa-ae89-4f6d-9956-bc1205264019",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Greenville Area Transit Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "600 S Pitt St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.greenvillenc.gov/government/public-works/great-bus-system/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=9628704861440376924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-area-transit-transfer-center",
      "poi_latitude": "35.6107129",
      "poi_longitude": "-77.37669799999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-329-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyA9OhLDrokRXAA7cQ4IoIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b7d3c03d-08af-4f9c-85c3-af7a562772c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "ECU Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "285 Easy St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-1d26-753e-8c98-20d629c64de8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e24-1d26-753e-8c98-20d629c64de8",
        "storage_key": "property/6737460151191769/019e1e24-1d26-753e-8c98-20d629c64de8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://transit.ecu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3325782697295989403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-transit",
      "poi_latitude": "35.6512491",
      "poi_longitude": "-77.3710717",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-328-4724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YXbuCXmrokRm8p3EL6NJy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7f8077ff-12bc-482e-b74d-18cb5a8cdc7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Speight Building",
      "poi_type": "Transportation & Transit",
      "poi_address": "Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-7cd2-767e-93f3-79d7a7643d63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-7cd2-767e-93f3-79d7a7643d63",
        "storage_key": "property/6737460151191769/019e1e26-7cd2-767e-93f3-79d7a7643d63.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15614689415313263120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speight-building",
      "poi_latitude": "35.6064805",
      "poi_longitude": "-77.36184159999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJby9WA-7nrokREIrMBUuFstg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "custom_8982e9dc-4cb0-4418-a7af-ffcbc4fe1c53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Rocky Mount",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 Coastline St, Rocky Mount, NC 27804, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-8136-732d-b41e-0ac52e09f56c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-8136-732d-b41e-0ac52e09f56c",
        "storage_key": "property/6737460151191769/019e1e26-8136-732d-b41e-0ac52e09f56c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=RMT",
      "poi_directions_map_url": "https://maps.google.com/?cid=7987060750082204118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rocky-mount",
      "poi_latitude": "35.9379596",
      "poi_longitude": "-77.79767609999999",
      "poi_miles_from_property": "35.9",
      "poi_walking_minutes": "12 hours 59 mins",
      "poi_biking_minutes": "3 hours 17 mins",
      "poi_driving_minutes": "50 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-b461-719f-9b36-d546d448a1a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e26-b461-719f-9b36-d546d448a1a1",
        "storage_key": "property/6737460151191769/019e1e26-b461-719f-9b36-d546d448a1a1.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS9IO_yGrokR1mEdWG-9124",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_7854b5f9-87ba-4f40-a3db-ac7989afdbcd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "ECU Health Sciences Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "North Campus Loop &, W Campus Loop, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-7e5c-7524-a9a8-b9055a7bce82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-7e5c-7524-a9a8-b9055a7bce82",
        "storage_key": "property/6737460151191769/019e1e26-7e5c-7524-a9a8-b9055a7bce82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.ecu.edu/health-sciences/",
      "poi_directions_map_url": "https://maps.google.com/?cid=192265241419659878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-health-sciences-campus",
      "poi_latitude": "35.6124687",
      "poi_longitude": "-77.40684499999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 252-328-6131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_aCGhurprokRZjp56TcQqwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8926f066-e6d7-4ecc-8446-390c0269253b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Pitt County Government",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1717 W 5th St #1601, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-8441-70d9-aa8d-228677d3d18b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-8441-70d9-aa8d-228677d3d18b",
        "storage_key": "property/6737460151191769/019e1e26-8441-70d9-aa8d-228677d3d18b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pittcountync.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9318982125478241845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-county-government",
      "poi_latitude": "35.611701",
      "poi_longitude": "-77.39914379999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 252-902-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3ad3-773a-873e-67d6ceb57f42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3ad3-773a-873e-67d6ceb57f42",
        "storage_key": "property/6737460151191769/019e1e24-3ad3-773a-873e-67d6ceb57f42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-42-VRborokRNWZYed6sU4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_1d874173-b988-4110-b92d-f4d52ffaecfb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "City of Greenville, NC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-7f93-72cd-b623-af857618a06c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-7f93-72cd-b623-af857618a06c",
        "storage_key": "property/6737460151191769/019e1e26-7f93-72cd-b623-af857618a06c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.greenvillenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14873217373618047209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-greenville-nc",
      "poi_latitude": "35.6115457",
      "poi_longitude": "-77.37436029999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-329-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3ad3-773a-873e-67d6ceb57f42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3ad3-773a-873e-67d6ceb57f42",
        "storage_key": "property/6737460151191769/019e1e24-3ad3-773a-873e-67d6ceb57f42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0FwuOPnrokR6QisTWZIaM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_90477efa-95c0-4759-be5e-156e5c74817c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Greenville Utilities Commission",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 S Greene St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-80c5-701a-84a3-63eb7dc4b2ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-80c5-701a-84a3-63eb7dc4b2ac",
        "storage_key": "property/6737460151191769/019e1e26-80c5-701a-84a3-63eb7dc4b2ac.webp",
        "width": 1280,
        "height": 986
      },
      "poi_business_url": "https://www.guc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=757033052474017965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-utilities-commission",
      "poi_latitude": "35.61211249999999",
      "poi_longitude": "-77.3743886",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 252-752-7166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYy-m2U3drokRrYjx34yFgQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_47dec22a-a0cb-4596-9321-741e2a303e0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Pitt County Health Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 Government Cir, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pittcountync.gov/229/Public-Health",
      "poi_directions_map_url": "https://maps.google.com/?cid=16528690716227200619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-county-health-department",
      "poi_latitude": "35.6372648",
      "poi_longitude": "-77.3635702",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-902-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZLvdBforokRa-YEN6K0YeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_lab"
    },
    {
      "id": "custom_4290602a-7fe6-4e86-bf91-692c5fad9c81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Pitt Community College Continuing Education, Greenville Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3107 S Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-86bc-7625-a557-86218837c933.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-86bc-7625-a557-86218837c933",
        "storage_key": "property/6737460151191769/019e1e26-86bc-7625-a557-86218837c933.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://pittcc.edu/community/continuing-education/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14963882823157554493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-community-college-continuing-education-greenville-center",
      "poi_latitude": "35.577564",
      "poi_longitude": "-77.397322",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-493-7388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3992-776f-b9f0-ceea1607a863",
        "storage_key": "property/6737460151191769/019e1e24-3992-776f-b9f0-ceea1607a863.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg0EXnsDCrokRPR3gRiVkqs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_ab121a01-6132-4812-9f93-2950ede393b4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "Attends Healthcare Products",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1029 Old Creek Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-8aee-70b1-b02a-f2796f3c1d1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-8aee-70b1-b02a-f2796f3c1d1a",
        "storage_key": "property/6737460151191769/019e1e26-8aee-70b1-b02a-f2796f3c1d1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.attends.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14805456882900107569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "attends-healthcare-products",
      "poi_latitude": "35.64244",
      "poi_longitude": "-77.350724",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-428-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-39ef-75ad-a6c4-157038215b46",
        "storage_key": "property/6737460151191769/019e1e24-39ef-75ad-a6c4-157038215b46.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjQZ9IEvmrokRMYGfopeMd80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_40a02d32-994b-4345-b095-4f6d9bfd0708",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "poi_name": "N.C. Cooperative Extension - Pitt County Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "403 Government Cir # 2, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e26-8b60-7679-b609-22b8b734e9c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e26-8b60-7679-b609-22b8b734e9c1",
        "storage_key": "property/6737460151191769/019e1e26-8b60-7679-b609-22b8b734e9c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pitt.ces.ncsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12178965176587450433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nc-cooperative-extension---pitt-county-center",
      "poi_latitude": "35.6396037",
      "poi_longitude": "-77.3605547",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-902-1709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e24-3ad3-773a-873e-67d6ceb57f42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e24-3ad3-773a-873e-67d6ceb57f42",
        "storage_key": "property/6737460151191769/019e1e24-3ad3-773a-873e-67d6ceb57f42.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMbIxU8vnrokRQfhYGk1gBKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_e42477e7-c563-4522-873f-fa546d83d9d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9095f3c0-01a3-47da-91f6-f8f4a5d86dac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b134eef7-bc67-48d6-af05-4b4851943123",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2b1c67c2-a391-4066-8cf3-00ba46ca0e5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_787aabaa-efab-4905-9ec5-849daa104247",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c71cbe33-d785-4c12-8328-17ca87610ae6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d32deb55-bc48-4f66-869c-456c8584c4e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "rating": "5.0",
      "name": "Punjapon Boonchua",
      "text": "We have received great services from the beginning. Leasing staffs are very friendly and helpful. We requested to see the apartment many times prior to signing the lease and the staffs were great accommodating to our needs. Their maintenance team is amazing. It’s easy to put a ticket in for service request and they respond to it in a timely manner.",
      "date": "2026-05-01",
      "title": ""
    },
    {
      "id": "custom_c6b23398-b4d8-494a-a15c-3c2e0f0706ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "rating": "5.0",
      "name": "Renee Carr",
      "text": "Our Maintenance guys are amazing. Doesn’t take them long to fix things. They’re very nice and respectful! My guys deserve a raise!!",
      "date": "2026-04-24",
      "title": ""
    },
    {
      "id": "custom_ebc1c5fa-91e6-4f2a-a699-6bf1ef144a09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "rating": "5",
      "name": "Courtney S.",
      "text": "This place is great. I am so anxious to have my little place I can call home soon. The property manager is absolutely the best person. He actually cares, he's very professional, and very welcoming. Definitely a great pick for the person and I hope it's my great pick for my place. Jermaine is an honest and very smart property manager. I can't tell anyone how great and quiet this place is. Very clean and great maintenance men as well.",
      "date": "2026-04-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ad726c6a-708f-4250-88de-62a5dec231a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019e1e23-eaef-7014-af73-693eed6adfe9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e23-eaef-7014-af73-693eed6adfe9",
        "storage_key": "property/6737460151191769/019e1e23-eaef-7014-af73-693eed6adfe9.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=671be0dd1e285b3821a63c4d"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fdb-5630-7539-893e-5683325e6216",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-signature-place-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769"
    },
    {
      "lead_collector_id": "019a2717-f19a-75dc-aa9d-16835d8f0c64",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-signature-place-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769"
    },
    {
      "lead_collector_id": "019d6350-8810-70ac-ad86-b4df847d9f7e",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-greenville-nc",
      "search_query": "apartments with in-unit laundry Greenville NC",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Greenville NC",
      "h2_subtitle": "Discover the charm of Signature Place, offering apartments with in-unit laundry in the heart of Greenville, NC. Experience unmatched convenience today!",
      "page_copy": "Signature Place in Greenville, NC, is the ideal location for those seeking modern convenience and style, featuring apartments with in-unit laundry. Located in the bustling area of West Greenville, you can select from our spacious one-, two-, or three-bedroom floor plans designed to match your lifestyle. Each apartment is equipped with upscale amenities, ensuring you enjoy everyday living with ease.\n\nAt Signature Place, our focus is on enhancing your life with comfort and convenience. Enjoy our refreshing pool, state-of-the-art fitness center, and inviting clubhouse. With features like furnished units and hardwood floors, our property is perfect for anyone looking to enjoy the benefits of smoke-free living in Pitt County. Schedule a visit today and see what makes Signature Place the top choice for apartments with in-unit laundry in Greenville NC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Greenville NC",
      "seo_description": "Find your new home at Signature Place. Our Greenville NC apartments feature in-unit laundry, modern amenities, and stylish designs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-west-greenville",
      "search_query": "air conditioned apartments West Greenville",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in West Greenville",
      "h2_subtitle": "Enjoy the comfort of air conditioned apartments at Signature Place, located in West Greenville. Experience ultimate relaxation and modern living today!",
      "page_copy": "Signature Place boasts air conditioned apartments in the vibrant neighborhood of West Greenville, providing residents with unparalleled comfort and modern convenience. Our community offers a selection of spacious one-, two-, and three-bedroom floor plans, each designed with your comfort in mind. \n\nBeyond your apartment, enjoy our variety of upscale amenities including a refreshing pool, contemporary fitness center, and welcoming clubhouse. With options like furnished units and convenient walk-up accessibility, Signature Place makes your lifestyle effortless. Embrace smoke-free living and enjoy recycling facilities that support a sustainable environment. Discover the perfect air conditioned apartment in West Greenville by visiting Signature Place today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in West Greenville",
      "seo_description": "Discover air conditioned living at Signature Place in West Greenville. Enjoy modern home comfort and enhanced quality of life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "dog-park-apartments-pitt-county",
      "search_query": "apartments with dog parks Pitt County",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Parks in Pitt County",
      "h2_subtitle": "Explore Signature Place in Pitt County, offering pet-friendly apartments with dog parks. A perfect home for you and your furry friend awaits!",
      "page_copy": "At Signature Place, located in the heart of Greenville, NC, we pride ourselves on being one of the premier pet-friendly communities with apartments featuring dog parks in Pitt County. Our one-, two-, and three-bedroom floor plans are designed with both you and your furry companions in mind, providing the perfect blend of comfort and convenience.\n\nSignature Place is more than just a pet haven. We offer premium amenities such as a refreshing pool, modern fitness center, and a welcoming clubhouse. Our smoke-free apartments also feature hardwood floors and furnished options, making it the ideal choice for modern living in West Greenville. Visit us today to uncover why Signature Place is the community for you and your pets!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Parks in Pitt County",
      "seo_description": "Find pet-friendly living at Signature Place in Pitt County with dog parks, enriching amenities, and inviting spaces for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "dishwasher-apartments-greenville-27834",
      "search_query": "apartments with dishwasher Greenville 27834",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Greenville 27834",
      "h2_subtitle": "Discover Signature Place in Greenville, where our apartments are equipped with dishwashers for your convenience. Modern living made easy in the 27834 area.",
      "page_copy": "Signature Place, nestled in Greenville's vibrant 27834 area, offers apartments equipped with the convenience of dishwashers. Our community presents a selection of spacious one-, two-, and three-bedroom floor plans, ensuring you find the perfect home tailored to your lifestyle.\n\nIn addition to in-unit dishwashers, residents enjoy an array of upscale amenities such as a sparkling pool, a state-of-the-art fitness center, and a welcoming clubhouse. With options like furnished units, smoke-free environments, and stylish hardwood floors, Signature Place prioritizes comfort and convenience. Visit us today and explore the benefits of living in Greenville’s sought-after 27834 neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Greenville 27834",
      "seo_description": "Experience modern living at Signature Place in Greenville 27834, with apartments featuring dishwashers and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "pool-apartments-west-greenville",
      "search_query": "apartments with pool in West Greenville",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in West Greenville",
      "h2_subtitle": "Experience the luxury of living at Signature Place in West Greenville, where our community features a stunning pool for relaxation and recreation.",
      "page_copy": "Located in the lively neighborhood of West Greenville, Signature Place offers exquisite apartment living featuring an inviting pool, perfect for cooling off or enjoying a leisurely afternoon. Choose from our selection of spacious one-, two-, and three-bedroom floor plans that cater to every lifestyle.\n\nBeyond the refreshing pool, our community offers a modern fitness center and a welcoming clubhouse, ensuring you have all the comforts and conveniences you need. Enjoy smoke-free living in beautifully designed apartments with hardwood floors and optional furnished units. Signature Place provides a vibrant living experience in West Greenville, combining style and functionality effortlessly. Explore our community today and discover your dream home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in West Greenville",
      "seo_description": "Find luxurious living at Signature Place with a pool in West Greenville. Enjoy spacious apartments and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-greenville-nc",
      "search_query": "1 bedroom apartments in greenville nc",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Greenville, NC",
      "h2_subtitle": "Discover cozy and stylish 1 bedroom apartments at Signature Place in Greenville, NC, designed to enhance your lifestyle with modern amenities.",
      "page_copy": "Signature Place, situated in vibrant Greenville, NC, offers beautifully designed 1 bedroom apartments perfect for singles and couples alike. Our thoughtfully planned floor plans provide ample living space, combining comfort with contemporary design for a seamless living experience.\n\nResidents at Signature Place enjoy access to an array of premium amenities, including a modern fitness center, a refreshing pool, and a welcoming clubhouse. Additional conveniences such as hardwood floors, smoke-free living, and optional furnished units further enhance the community's appeal. Experience the perfect blend of tranquility and accessibility at Signature Place in Greenville, NC. Schedule a tour today and find your ideal home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Greenville, NC",
      "seo_description": "Explore Signature Place for stylish 1 bedroom apartments in Greenville, NC, with modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-pitt-county",
      "search_query": "2 bedroom apartments pitt county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Pitt County",
      "h2_subtitle": "Explore our spacious 2 bedroom apartments at Signature Place in Pitt County. Enjoy comfort, style, and convenience in a vibrant community setting.",
      "page_copy": "Located in the heart of Pitt County, Signature Place offers stunning 2 bedroom apartments ideal for families or roommates. Each unit combines practicality with modern design, providing the perfect space to create your home.\n\nSignature Place residents benefit from a host of amenities, including a state-of-the-art fitness center and a sparkling pool, ensuring leisure and recreation right at your doorstep. With smoke-free living, hardwood floors, and the option of furnished units, living in Pitt County has never been more rewarding. Start your journey to a new lifestyle today by visiting Signature Place.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Pitt County",
      "seo_description": "Discover Signature Place's spacious 2 bedroom apartments in Pitt County with modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191769",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-west-greenville",
      "search_query": "3 bedroom apartments west greenville",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in West Greenville",
      "h2_subtitle": "Discover spacious 3 bedroom apartments at Signature Place in West Greenville. Perfect for families looking for comfort and convenience.",
      "page_copy": "Signature Place in West Greenville offers roomy 3 bedroom apartments designed to accommodate growing families or those seeking extra space. Each apartment combines contemporary features with an inviting layout, making it the perfect place to call home.\n\nOur community boasts premium amenities including a refreshing pool, modern fitness center, and a welcoming clubhouse, all contributing to a vibrant living experience. The apartments come with smoke-free living, elegant hardwood floors, and options for furnished units. Embrace quality living in West Greenville at Signature Place. Schedule a tour today to find the home you've been dreaming of.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray subway tile backsplash.",
        "public_id": "019d076e-dd71-75ce-8d3f-be844168ae33",
        "storage_key": "property/6737460151191769/019d076e-dd71-75ce-8d3f-be844168ae33.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in West Greenville",
      "seo_description": "Explore spacious 3 bedroom apartments at Signature Place in West Greenville, offering modern amenities in a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3406"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483456"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4882051"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W8TRJ45D"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "262-300-4052"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "262-228-9924"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "262-233-9971"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "262-228-9294"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "262-228-9979"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "262-333-6828"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "262-228-9976"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "262-228-9704"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "262-228-9886"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "262-404-3210"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "262-228-9557"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "262-261-1341"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "252-518-6974"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "262-944-2379"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "262-430-0240"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "262-228-9954"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "262-588-3146"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321283408"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "262-300-4048"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "262-667-7151"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "2b6b81b4111eef0b"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "262-883-8734"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "262-379-3449"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "262-261-1241"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "262-261-1254"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "262-419-3592"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "262-229-6428"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "262-261-1362"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "262-228-9950"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.signatureplaceapartments.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191769/019e84aa-d510-71ee-a1c6-8e8881c6d564.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "262-300-7085"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "262-404-3210"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3406",
  "custom_repli_id": "5028483456",
  "custom_realpage_id": "4882051",
  "custom_knock_a_link": "https://www.signatureplaceapartments.com?utm_knock=a",
  "custom_knock_g_link": "https://www.signatureplaceapartments.com?utm_knock=g",
  "custom_knock_r_link": "https://www.signatureplaceapartments.com?utm_knock=r",
  "custom_knock_w_link": "https://www.signatureplaceapartments.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-W8TRJ45D",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.signatureplaceapartments.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.signatureplaceapartments.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.signatureplaceapartments.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.signatureplaceapartments.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.signatureplaceapartments.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.signatureplaceapartments.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "262-300-4052",
  "custom_knock_ads_link": "https://www.signatureplaceapartments.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.signatureplaceapartments.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "262-228-9924",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.signatureplaceapartments.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.signatureplaceapartments.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.signatureplaceapartments.com?utm_knock=ppn",
  "custom_knock_r_number": "262-233-9971",
  "custom_knock_w_number": "262-228-9294",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "262-228-9979",
  "custom_knock_amap_link": "https://www.signatureplaceapartments.com?utm_knock=amap",
  "custom_knock_ar_number": "262-333-6828",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "262-228-9976",
  "custom_knock_fb_number": "262-228-9704",
  "custom_knock_fl_number": "262-228-9886",
  "custom_knock_gp_number": "262-404-3210",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.signatureplaceapartments.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "262-228-9557",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.signatureplaceapartments.com?utm_knock=bcard",
  "custom_knock_bnr_number": "262-261-1341",
  "custom_knock_cfres_link": "https://www.signatureplaceapartments.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "252-518-6974",
  "custom_knock_lgp_number": "262-944-2379",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.signatureplaceapartments.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "262-430-0240",
  "custom_knock_psocl_link": "https://www.signatureplaceapartments.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "262-228-9954",
  "custom_knock_bandit_link": "https://www.signatureplaceapartments.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.signatureplaceapartments.com?utm_knock=flyers",
  "custom_knock_osoc_number": "262-588-3146",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321283408",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "262-300-4048",
  "custom_knock_cfres_number": "262-667-7151",
  "custom_knock_chatgpt_link": "https://www.signatureplaceapartments.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "2b6b81b4111eef0b",
  "custom_knock_dirmail_link": "https://www.signatureplaceapartments.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "262-883-8734",
  "custom_knock_propbro_link": "https://www.signatureplaceapartments.com?utm_knock=propbro",
  "custom_knock_psocl_number": "262-379-3449",
  "custom_knock_bandit_number": "262-261-1241",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "262-261-1254",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.signatureplaceapartments.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "262-419-3592",
  "custom_knock_dirmail_number": "262-229-6428",
  "custom_knock_propbro_number": "262-261-1362",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "262-228-9950",
  "custom_knock_maintenance_link": "https://www.signatureplaceapartments.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191769/019e84aa-d510-71ee-a1c6-8e8881c6d564.mp4",
  "custom_knock_maintenance_number": "262-300-7085",
  "custom_ppc_tracking_phone_number": "262-404-3210"
};

export const generatedAt = '2026-10-07T17:15:16.833Z';
